import { createElementBlock as A, openBlock as w, createElementVNode as p, defineComponent as ae, createCommentVNode as q, normalizeStyle as ze, createStaticVNode as $n, toDisplayString as ne, withModifiers as Se, createVNode as Q, watch as ce, computed as k, toValue as et, unref as h, ref as M, shallowRef as wo, getCurrentScope as Co, onScopeDispose as $o, shallowReadonly as st, onMounted as vt, onUnmounted as Sn, createBlock as oe, Teleport as Jn, renderSlot as In, normalizeClass as J, Fragment as de, renderList as pe, withDirectives as ke, withKeys as nt, vModelText as Ze, withCtx as Pe, createTextVNode as Qn, inject as So, nextTick as Vt, vModelSelect as Dn, vModelCheckbox as Io, toRef as Xe, toRaw as Te, mergeModels as Ln, useModel as Je, provide as To } from "vue";
const ge = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, Eo = {}, ko = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "currentColor"
};
function Mo(e, t) {
  return w(), A("svg", ko, [...t[0] || (t[0] = [
    p("path", { d: "M294-238.35 239.35-294l185-186-185-186L294-721.65l186 186 186-186L720.65-666l-185 186 185 186L666-238.35l-186-186-186 186Z" }, null, -1)
  ])]);
}
const zt = /* @__PURE__ */ ge(Eo, [["render", Mo]]), Ao = { class: "relative group flex flex-col items-center z-0" }, Bo = { class: "relative" }, Ro = {
  class: "text-white font-bold text-4xl",
  style: { "text-shadow": "0 2px 4px rgba(0, 0, 0, 0.2)" }
}, Do = /* @__PURE__ */ ae({
  __name: "PopulationIcon",
  props: {
    name: {},
    count: {},
    color: {},
    showDelete: { type: Boolean, default: !0 }
  },
  emits: ["delete", "click"],
  setup(e) {
    return (t, n) => (w(), A("div", Ao, [
      p("div", Bo, [
        p("div", {
          class: "size-48 rounded-full flex flex-col items-center justify-center cursor-pointer transition-all hover:brightness-95 shadow-lg",
          style: ze({ backgroundColor: e.color }),
          onClick: n[0] || (n[0] = (o) => t.$emit("click"))
        }, [
          n[2] || (n[2] = $n('<svg width="36" height="30" viewBox="0 0 36 30" fill="white" xmlns="http://www.w3.org/2000/svg"><path d="M24 6C24 9.31371 21.3137 12 18 12C14.6863 12 12 9.31371 12 6C12 2.68629 14.6863 0 18 0C21.3137 0 24 2.68629 24 6Z"></path><path d="M34 10C34 12.2091 32.2091 14 30 14C27.7909 14 26 12.2091 26 10C26 7.79086 27.7909 6 30 6C32.2091 6 34 7.79086 34 10Z"></path><path d="M26 24C26 19.5817 22.4183 16 18 16C13.5817 16 10 19.5817 10 24V30H26V24Z"></path><path d="M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10Z"></path><path d="M30 30V24C30 21.8917 29.4563 19.9104 28.5015 18.1886C28.9805 18.0655 29.4826 18 30 18C33.3137 18 36 20.6863 36 24V30H30Z"></path><path d="M7.49853 18.1886C6.5437 19.9104 6 21.8917 6 24V30H0V24C0 20.6863 2.68629 18 6 18C6.51742 18 7.01954 18.0655 7.49853 18.1886Z"></path></svg>', 1)),
          p("span", Ro, ne(e.count), 1)
        ], 4),
        e.showDelete ? (w(), A("button", {
          key: 0,
          class: "absolute cursor-pointer -top-2 -right-2 text-red-500 hover:text-red-700 bg-white hover:bg-red-50 hover:scale-110 group-hover:opacity-100 opacity-0 transition-all rounded-full p-1 flex shadow-md",
          title: "Delete Population",
          onClick: n[1] || (n[1] = Se((o) => t.$emit("delete"), ["stop"]))
        }, [
          Q(zt)
        ])) : q("", !0)
      ])
    ]));
  }
}), Lo = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const No = Object.prototype.toString, Po = (e) => No.call(e) === "[object Object]", Bt = () => {
};
function sn(e) {
  return Array.isArray(e) ? e : [e];
}
function Vo(e, t, n) {
  return ce(e, t, {
    ...n,
    immediate: !0
  });
}
const eo = Lo ? window : void 0;
function bt(e) {
  var t;
  const n = et(e);
  return (t = n?.$el) !== null && t !== void 0 ? t : n;
}
function an(...e) {
  const t = (o, i, r, l) => (o.addEventListener(i, r, l), () => o.removeEventListener(i, r, l)), n = k(() => {
    const o = sn(et(e[0])).filter((i) => i != null);
    return o.every((i) => typeof i != "string") ? o : void 0;
  });
  return Vo(() => {
    var o, i;
    return [
      (o = (i = n.value) === null || i === void 0 ? void 0 : i.map((r) => bt(r))) !== null && o !== void 0 ? o : [eo].filter((r) => r != null),
      sn(et(n.value ? e[1] : e[0])),
      sn(h(n.value ? e[2] : e[1])),
      et(n.value ? e[3] : e[2])
    ];
  }, ([o, i, r, l], s, d) => {
    if (!o?.length || !i?.length || !r?.length) return;
    const u = Po(l) ? { ...l } : l, m = o.flatMap((c) => i.flatMap((a) => r.map((f) => t(c, a, f, u))));
    d(() => {
      m.forEach((c) => c());
    });
  }, { flush: "post" });
}
function Oo(e, t, n = {}) {
  const { window: o = eo, ignore: i = [], capture: r = !0, detectIframe: l = !1, controls: s = !1 } = n;
  if (!o) return s ? {
    stop: Bt,
    cancel: Bt,
    trigger: Bt
  } : Bt;
  let d = !0;
  const u = ($) => et(i).some((E) => {
    if (typeof E == "string") return Array.from(o.document.querySelectorAll(E)).some((x) => x === $.target || $.composedPath().includes(x));
    {
      const x = bt(E);
      return x && ($.target === x || $.composedPath().includes(x));
    }
  });
  function m($) {
    const E = et($);
    return E && E.$.subTree.shapeFlag === 16;
  }
  function c($, E) {
    const x = et($), g = x.$.subTree && x.$.subTree.children;
    return g == null || !Array.isArray(g) ? !1 : g.some((y) => y.el === E.target || E.composedPath().includes(y.el));
  }
  const a = ($) => {
    const E = bt(e);
    if ($.target != null && !(!(E instanceof Element) && m(e) && c(e, $)) && !(!E || E === $.target || $.composedPath().includes(E))) {
      if ("detail" in $ && $.detail === 0 && (d = !u($)), !d) {
        d = !0;
        return;
      }
      t($);
    }
  };
  let f = !1;
  const v = [
    an(o, "click", ($) => {
      f || (f = !0, setTimeout(() => {
        f = !1;
      }, 0), a($));
    }, {
      passive: !0,
      capture: r
    }),
    an(o, "pointerdown", ($) => {
      const E = bt(e);
      d = !u($) && !!(E && !$.composedPath().includes(E));
    }, { passive: !0 }),
    l && an(o, "blur", ($) => {
      setTimeout(() => {
        var E;
        const x = bt(e);
        ((E = o.document.activeElement) === null || E === void 0 ? void 0 : E.tagName) === "IFRAME" && !x?.contains(o.document.activeElement) && t($);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), T = () => v.forEach(($) => $());
  return s ? {
    stop: T,
    cancel: () => {
      d = !1;
    },
    trigger: ($) => {
      d = !0, a($), d = !1;
    }
  } : T;
}
const ct = Math.min, tt = Math.max, Ot = Math.round, Rt = Math.floor, Ne = (e) => ({
  x: e,
  y: e
}), Ho = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Fo = {
  start: "end",
  end: "start"
};
function mn(e, t, n) {
  return tt(e, ct(t, n));
}
function ot(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ye(e) {
  return e.split("-")[0];
}
function Ct(e) {
  return e.split("-")[1];
}
function Tn(e) {
  return e === "x" ? "y" : "x";
}
function En(e) {
  return e === "y" ? "height" : "width";
}
const zo = /* @__PURE__ */ new Set(["top", "bottom"]);
function Fe(e) {
  return zo.has(Ye(e)) ? "y" : "x";
}
function kn(e) {
  return Tn(Fe(e));
}
function Zo(e, t, n) {
  n === void 0 && (n = !1);
  const o = Ct(e), i = kn(e), r = En(i);
  let l = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (l = Ht(l)), [l, Ht(l)];
}
function jo(e) {
  const t = Ht(e);
  return [gn(e), t, gn(t)];
}
function gn(e) {
  return e.replace(/start|end/g, (t) => Fo[t]);
}
const Nn = ["left", "right"], Pn = ["right", "left"], Uo = ["top", "bottom"], Wo = ["bottom", "top"];
function qo(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Pn : Nn : t ? Nn : Pn;
    case "left":
    case "right":
      return t ? Uo : Wo;
    default:
      return [];
  }
}
function Xo(e, t, n, o) {
  const i = Ct(e);
  let r = qo(Ye(e), n === "start", o);
  return i && (r = r.map((l) => l + "-" + i), t && (r = r.concat(r.map(gn)))), r;
}
function Ht(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ho[t]);
}
function Go(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function to(e) {
  return typeof e != "number" ? Go(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ft(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Vn(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const r = Fe(t), l = kn(t), s = En(l), d = Ye(t), u = r === "y", m = o.x + o.width / 2 - i.width / 2, c = o.y + o.height / 2 - i.height / 2, a = o[s] / 2 - i[s] / 2;
  let f;
  switch (d) {
    case "top":
      f = {
        x: m,
        y: o.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: m,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: c
      };
      break;
    case "left":
      f = {
        x: o.x - i.width,
        y: c
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  switch (Ct(t)) {
    case "start":
      f[l] -= a * (n && u ? -1 : 1);
      break;
    case "end":
      f[l] += a * (n && u ? -1 : 1);
      break;
  }
  return f;
}
async function Yo(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: l,
    elements: s,
    strategy: d
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: c = "floating",
    altBoundary: a = !1,
    padding: f = 0
  } = ot(t, e), v = to(f), $ = s[a ? c === "floating" ? "reference" : "floating" : c], E = Ft(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement($))) == null || n ? $ : $.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: m,
    strategy: d
  })), x = c === "floating" ? {
    x: o,
    y: i,
    width: l.floating.width,
    height: l.floating.height
  } : l.reference, g = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), y = await (r.isElement == null ? void 0 : r.isElement(g)) ? await (r.getScale == null ? void 0 : r.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ft(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: g,
    strategy: d
  }) : x);
  return {
    top: (E.top - S.top + v.top) / y.y,
    bottom: (S.bottom - E.bottom + v.bottom) / y.y,
    left: (E.left - S.left + v.left) / y.x,
    right: (S.right - E.right + v.right) / y.x
  };
}
const _o = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: l
  } = n, s = r.filter(Boolean), d = await (l.isRTL == null ? void 0 : l.isRTL(t));
  let u = await l.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: m,
    y: c
  } = Vn(u, o, d), a = o, f = {}, v = 0;
  for (let $ = 0; $ < s.length; $++) {
    var T;
    const {
      name: E,
      fn: x
    } = s[$], {
      x: g,
      y,
      data: S,
      reset: b
    } = await x({
      x: m,
      y: c,
      initialPlacement: o,
      placement: a,
      strategy: i,
      middlewareData: f,
      rects: u,
      platform: {
        ...l,
        detectOverflow: (T = l.detectOverflow) != null ? T : Yo
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    m = g ?? m, c = y ?? c, f = {
      ...f,
      [E]: {
        ...f[E],
        ...S
      }
    }, b && v <= 50 && (v++, typeof b == "object" && (b.placement && (a = b.placement), b.rects && (u = b.rects === !0 ? await l.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : b.rects), {
      x: m,
      y: c
    } = Vn(u, a, d)), $ = -1);
  }
  return {
    x: m,
    y: c,
    placement: a,
    strategy: i,
    middlewareData: f
  };
}, Ko = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: l,
      elements: s,
      middlewareData: d
    } = t, {
      element: u,
      padding: m = 0
    } = ot(e, t) || {};
    if (u == null)
      return {};
    const c = to(m), a = {
      x: n,
      y: o
    }, f = kn(i), v = En(f), T = await l.getDimensions(u), $ = f === "y", E = $ ? "top" : "left", x = $ ? "bottom" : "right", g = $ ? "clientHeight" : "clientWidth", y = r.reference[v] + r.reference[f] - a[f] - r.floating[v], S = a[f] - r.reference[f], b = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(u));
    let C = b ? b[g] : 0;
    (!C || !await (l.isElement == null ? void 0 : l.isElement(b))) && (C = s.floating[g] || r.floating[v]);
    const B = y / 2 - S / 2, O = C / 2 - T[v] / 2 - 1, P = ct(c[E], O), U = ct(c[x], O), _ = P, z = C - T[v] - U, X = C / 2 - T[v] / 2 + B, ee = mn(_, X, z), le = !d.arrow && Ct(i) != null && X !== ee && r.reference[v] / 2 - (X < _ ? P : U) - T[v] / 2 < 0, ie = le ? X < _ ? X - _ : X - z : 0;
    return {
      [f]: a[f] + ie,
      data: {
        [f]: ee,
        centerOffset: X - ee - ie,
        ...le && {
          alignmentOffset: ie
        }
      },
      reset: le
    };
  }
}), Jo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: l,
        initialPlacement: s,
        platform: d,
        elements: u
      } = t, {
        mainAxis: m = !0,
        crossAxis: c = !0,
        fallbackPlacements: a,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: T = !0,
        ...$
      } = ot(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const E = Ye(i), x = Fe(s), g = Ye(s) === s, y = await (d.isRTL == null ? void 0 : d.isRTL(u.floating)), S = a || (g || !T ? [Ht(s)] : jo(s)), b = v !== "none";
      !a && b && S.push(...Xo(s, T, v, y));
      const C = [s, ...S], B = await d.detectOverflow(t, $), O = [];
      let P = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (m && O.push(B[E]), c) {
        const X = Zo(i, l, y);
        O.push(B[X[0]], B[X[1]]);
      }
      if (P = [...P, {
        placement: i,
        overflows: O
      }], !O.every((X) => X <= 0)) {
        var U, _;
        const X = (((U = r.flip) == null ? void 0 : U.index) || 0) + 1, ee = C[X];
        if (ee && (!(c === "alignment" ? x !== Fe(ee) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((te) => Fe(te.placement) === x ? te.overflows[0] > 0 : !0)))
          return {
            data: {
              index: X,
              overflows: P
            },
            reset: {
              placement: ee
            }
          };
        let le = (_ = P.filter((ie) => ie.overflows[0] <= 0).sort((ie, te) => ie.overflows[1] - te.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!le)
          switch (f) {
            case "bestFit": {
              var z;
              const ie = (z = P.filter((te) => {
                if (b) {
                  const re = Fe(te.placement);
                  return re === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  re === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((re) => re > 0).reduce((re, me) => re + me, 0)]).sort((te, re) => te[1] - re[1])[0]) == null ? void 0 : z[0];
              ie && (le = ie);
              break;
            }
            case "initialPlacement":
              le = s;
              break;
          }
        if (i !== le)
          return {
            reset: {
              placement: le
            }
          };
      }
      return {};
    }
  };
}, no = /* @__PURE__ */ new Set(["left", "top"]);
async function Qo(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), l = Ye(n), s = Ct(n), d = Fe(n) === "y", u = no.has(l) ? -1 : 1, m = r && d ? -1 : 1, c = ot(t, e);
  let {
    mainAxis: a,
    crossAxis: f,
    alignmentAxis: v
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return s && typeof v == "number" && (f = s === "end" ? v * -1 : v), d ? {
    x: f * m,
    y: a * u
  } : {
    x: a * u,
    y: f * m
  };
}
const ei = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: l,
        middlewareData: s
      } = t, d = await Qo(t, e);
      return l === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: i + d.x,
        y: r + d.y,
        data: {
          ...d,
          placement: l
        }
      };
    }
  };
}, ti = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i,
        platform: r
      } = t, {
        mainAxis: l = !0,
        crossAxis: s = !1,
        limiter: d = {
          fn: (E) => {
            let {
              x,
              y: g
            } = E;
            return {
              x,
              y: g
            };
          }
        },
        ...u
      } = ot(e, t), m = {
        x: n,
        y: o
      }, c = await r.detectOverflow(t, u), a = Fe(Ye(i)), f = Tn(a);
      let v = m[f], T = m[a];
      if (l) {
        const E = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", g = v + c[E], y = v - c[x];
        v = mn(g, v, y);
      }
      if (s) {
        const E = a === "y" ? "top" : "left", x = a === "y" ? "bottom" : "right", g = T + c[E], y = T - c[x];
        T = mn(g, T, y);
      }
      const $ = d.fn({
        ...t,
        [f]: v,
        [a]: T
      });
      return {
        ...$,
        data: {
          x: $.x - n,
          y: $.y - o,
          enabled: {
            [f]: l,
            [a]: s
          }
        }
      };
    }
  };
}, ni = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: i,
        rects: r,
        middlewareData: l
      } = t, {
        offset: s = 0,
        mainAxis: d = !0,
        crossAxis: u = !0
      } = ot(e, t), m = {
        x: n,
        y: o
      }, c = Fe(i), a = Tn(c);
      let f = m[a], v = m[c];
      const T = ot(s, t), $ = typeof T == "number" ? {
        mainAxis: T,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...T
      };
      if (d) {
        const g = a === "y" ? "height" : "width", y = r.reference[a] - r.floating[g] + $.mainAxis, S = r.reference[a] + r.reference[g] - $.mainAxis;
        f < y ? f = y : f > S && (f = S);
      }
      if (u) {
        var E, x;
        const g = a === "y" ? "width" : "height", y = no.has(Ye(i)), S = r.reference[c] - r.floating[g] + (y && ((E = l.offset) == null ? void 0 : E[c]) || 0) + (y ? 0 : $.crossAxis), b = r.reference[c] + r.reference[g] + (y ? 0 : ((x = l.offset) == null ? void 0 : x[c]) || 0) - (y ? $.crossAxis : 0);
        v < S ? v = S : v > b && (v = b);
      }
      return {
        [a]: f,
        [c]: v
      };
    }
  };
};
function Zt() {
  return typeof window < "u";
}
function lt(e) {
  return Mn(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ie(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Oe(e) {
  var t;
  return (t = (Mn(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Mn(e) {
  return Zt() ? e instanceof Node || e instanceof Ie(e).Node : !1;
}
function De(e) {
  return Zt() ? e instanceof Element || e instanceof Ie(e).Element : !1;
}
function Ve(e) {
  return Zt() ? e instanceof HTMLElement || e instanceof Ie(e).HTMLElement : !1;
}
function On(e) {
  return !Zt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ie(e).ShadowRoot;
}
const oi = /* @__PURE__ */ new Set(["inline", "contents"]);
function $t(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = Le(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !oi.has(i);
}
const ii = /* @__PURE__ */ new Set(["table", "td", "th"]);
function li(e) {
  return ii.has(lt(e));
}
const ri = [":popover-open", ":modal"];
function jt(e) {
  return ri.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const si = ["transform", "translate", "scale", "rotate", "perspective"], ai = ["transform", "translate", "scale", "rotate", "perspective", "filter"], ui = ["paint", "layout", "strict", "content"];
function An(e) {
  const t = Bn(), n = De(e) ? Le(e) : e;
  return si.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ai.some((o) => (n.willChange || "").includes(o)) || ui.some((o) => (n.contain || "").includes(o));
}
function ci(e) {
  let t = _e(e);
  for (; Ve(t) && !dt(t); ) {
    if (An(t))
      return t;
    if (jt(t))
      return null;
    t = _e(t);
  }
  return null;
}
function Bn() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const di = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function dt(e) {
  return di.has(lt(e));
}
function Le(e) {
  return Ie(e).getComputedStyle(e);
}
function Ut(e) {
  return De(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function _e(e) {
  if (lt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    On(e) && e.host || // Fallback.
    Oe(e)
  );
  return On(t) ? t.host : t;
}
function oo(e) {
  const t = _e(e);
  return dt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ve(t) && $t(t) ? t : oo(t);
}
function yt(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = oo(e), r = i === ((o = e.ownerDocument) == null ? void 0 : o.body), l = Ie(i);
  if (r) {
    const s = hn(l);
    return t.concat(l, l.visualViewport || [], $t(i) ? i : [], s && n ? yt(s) : []);
  }
  return t.concat(i, yt(i, [], n));
}
function hn(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function io(e) {
  const t = Le(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = Ve(e), r = i ? e.offsetWidth : n, l = i ? e.offsetHeight : o, s = Ot(n) !== r || Ot(o) !== l;
  return s && (n = r, o = l), {
    width: n,
    height: o,
    $: s
  };
}
function Rn(e) {
  return De(e) ? e : e.contextElement;
}
function ut(e) {
  const t = Rn(e);
  if (!Ve(t))
    return Ne(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = io(t);
  let l = (r ? Ot(n.width) : n.width) / o, s = (r ? Ot(n.height) : n.height) / i;
  return (!l || !Number.isFinite(l)) && (l = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: l,
    y: s
  };
}
const vi = /* @__PURE__ */ Ne(0);
function lo(e) {
  const t = Ie(e);
  return !Bn() || !t.visualViewport ? vi : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function fi(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ie(e) ? !1 : t;
}
function it(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), r = Rn(e);
  let l = Ne(1);
  t && (o ? De(o) && (l = ut(o)) : l = ut(e));
  const s = fi(r, n, o) ? lo(r) : Ne(0);
  let d = (i.left + s.x) / l.x, u = (i.top + s.y) / l.y, m = i.width / l.x, c = i.height / l.y;
  if (r) {
    const a = Ie(r), f = o && De(o) ? Ie(o) : o;
    let v = a, T = hn(v);
    for (; T && o && f !== v; ) {
      const $ = ut(T), E = T.getBoundingClientRect(), x = Le(T), g = E.left + (T.clientLeft + parseFloat(x.paddingLeft)) * $.x, y = E.top + (T.clientTop + parseFloat(x.paddingTop)) * $.y;
      d *= $.x, u *= $.y, m *= $.x, c *= $.y, d += g, u += y, v = Ie(T), T = hn(v);
    }
  }
  return Ft({
    width: m,
    height: c,
    x: d,
    y: u
  });
}
function Wt(e, t) {
  const n = Ut(e).scrollLeft;
  return t ? t.left + n : it(Oe(e)).left + n;
}
function ro(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Wt(e, n), i = n.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function pi(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const r = i === "fixed", l = Oe(o), s = t ? jt(t.floating) : !1;
  if (o === l || s && r)
    return n;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Ne(1);
  const m = Ne(0), c = Ve(o);
  if ((c || !c && !r) && ((lt(o) !== "body" || $t(l)) && (d = Ut(o)), Ve(o))) {
    const f = it(o);
    u = ut(o), m.x = f.x + o.clientLeft, m.y = f.y + o.clientTop;
  }
  const a = l && !c && !r ? ro(l, d) : Ne(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - d.scrollLeft * u.x + m.x + a.x,
    y: n.y * u.y - d.scrollTop * u.y + m.y + a.y
  };
}
function mi(e) {
  return Array.from(e.getClientRects());
}
function gi(e) {
  const t = Oe(e), n = Ut(e), o = e.ownerDocument.body, i = tt(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = tt(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let l = -n.scrollLeft + Wt(e);
  const s = -n.scrollTop;
  return Le(o).direction === "rtl" && (l += tt(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: l,
    y: s
  };
}
const Hn = 25;
function hi(e, t) {
  const n = Ie(e), o = Oe(e), i = n.visualViewport;
  let r = o.clientWidth, l = o.clientHeight, s = 0, d = 0;
  if (i) {
    r = i.width, l = i.height;
    const m = Bn();
    (!m || m && t === "fixed") && (s = i.offsetLeft, d = i.offsetTop);
  }
  const u = Wt(o);
  if (u <= 0) {
    const m = o.ownerDocument, c = m.body, a = getComputedStyle(c), f = m.compatMode === "CSS1Compat" && parseFloat(a.marginLeft) + parseFloat(a.marginRight) || 0, v = Math.abs(o.clientWidth - c.clientWidth - f);
    v <= Hn && (r -= v);
  } else u <= Hn && (r += u);
  return {
    width: r,
    height: l,
    x: s,
    y: d
  };
}
const xi = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function bi(e, t) {
  const n = it(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, r = Ve(e) ? ut(e) : Ne(1), l = e.clientWidth * r.x, s = e.clientHeight * r.y, d = i * r.x, u = o * r.y;
  return {
    width: l,
    height: s,
    x: d,
    y: u
  };
}
function Fn(e, t, n) {
  let o;
  if (t === "viewport")
    o = hi(e, n);
  else if (t === "document")
    o = gi(Oe(e));
  else if (De(t))
    o = bi(t, n);
  else {
    const i = lo(e);
    o = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return Ft(o);
}
function so(e, t) {
  const n = _e(e);
  return n === t || !De(n) || dt(n) ? !1 : Le(n).position === "fixed" || so(n, t);
}
function yi(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = yt(e, [], !1).filter((s) => De(s) && lt(s) !== "body"), i = null;
  const r = Le(e).position === "fixed";
  let l = r ? _e(e) : e;
  for (; De(l) && !dt(l); ) {
    const s = Le(l), d = An(l);
    !d && s.position === "fixed" && (i = null), (r ? !d && !i : !d && s.position === "static" && !!i && xi.has(i.position) || $t(l) && !d && so(e, l)) ? o = o.filter((m) => m !== l) : i = s, l = _e(l);
  }
  return t.set(e, o), o;
}
function wi(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const l = [...n === "clippingAncestors" ? jt(t) ? [] : yi(t, this._c) : [].concat(n), o], s = l[0], d = l.reduce((u, m) => {
    const c = Fn(t, m, i);
    return u.top = tt(c.top, u.top), u.right = ct(c.right, u.right), u.bottom = ct(c.bottom, u.bottom), u.left = tt(c.left, u.left), u;
  }, Fn(t, s, i));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function Ci(e) {
  const {
    width: t,
    height: n
  } = io(e);
  return {
    width: t,
    height: n
  };
}
function $i(e, t, n) {
  const o = Ve(t), i = Oe(t), r = n === "fixed", l = it(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Ne(0);
  function u() {
    d.x = Wt(i);
  }
  if (o || !o && !r)
    if ((lt(t) !== "body" || $t(i)) && (s = Ut(t)), o) {
      const f = it(t, !0, r, t);
      d.x = f.x + t.clientLeft, d.y = f.y + t.clientTop;
    } else i && u();
  r && !o && i && u();
  const m = i && !o && !r ? ro(i, s) : Ne(0), c = l.left + s.scrollLeft - d.x - m.x, a = l.top + s.scrollTop - d.y - m.y;
  return {
    x: c,
    y: a,
    width: l.width,
    height: l.height
  };
}
function un(e) {
  return Le(e).position === "static";
}
function zn(e, t) {
  if (!Ve(e) || Le(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Oe(e) === n && (n = n.ownerDocument.body), n;
}
function ao(e, t) {
  const n = Ie(e);
  if (jt(e))
    return n;
  if (!Ve(e)) {
    let i = _e(e);
    for (; i && !dt(i); ) {
      if (De(i) && !un(i))
        return i;
      i = _e(i);
    }
    return n;
  }
  let o = zn(e, t);
  for (; o && li(o) && un(o); )
    o = zn(o, t);
  return o && dt(o) && un(o) && !An(o) ? n : o || ci(e) || n;
}
const Si = async function(e) {
  const t = this.getOffsetParent || ao, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: $i(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ii(e) {
  return Le(e).direction === "rtl";
}
const Ti = {
  convertOffsetParentRelativeRectToViewportRelativeRect: pi,
  getDocumentElement: Oe,
  getClippingRect: wi,
  getOffsetParent: ao,
  getElementRects: Si,
  getClientRects: mi,
  getDimensions: Ci,
  getScale: ut,
  isElement: De,
  isRTL: Ii
};
function uo(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Ei(e, t) {
  let n = null, o;
  const i = Oe(e);
  function r() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function l(s, d) {
    s === void 0 && (s = !1), d === void 0 && (d = 1), r();
    const u = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: a,
      height: f
    } = u;
    if (s || t(), !a || !f)
      return;
    const v = Rt(c), T = Rt(i.clientWidth - (m + a)), $ = Rt(i.clientHeight - (c + f)), E = Rt(m), g = {
      rootMargin: -v + "px " + -T + "px " + -$ + "px " + -E + "px",
      threshold: tt(0, ct(1, d)) || 1
    };
    let y = !0;
    function S(b) {
      const C = b[0].intersectionRatio;
      if (C !== d) {
        if (!y)
          return l();
        C ? l(!1, C) : o = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !uo(u, e.getBoundingClientRect()) && l(), y = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...g,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, g);
    }
    n.observe(e);
  }
  return l(!0), r;
}
function ki(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: l = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = o, u = Rn(e), m = i || r ? [...u ? yt(u) : [], ...yt(t)] : [];
  m.forEach((E) => {
    i && E.addEventListener("scroll", n, {
      passive: !0
    }), r && E.addEventListener("resize", n);
  });
  const c = u && s ? Ei(u, n) : null;
  let a = -1, f = null;
  l && (f = new ResizeObserver((E) => {
    let [x] = E;
    x && x.target === u && f && (f.unobserve(t), cancelAnimationFrame(a), a = requestAnimationFrame(() => {
      var g;
      (g = f) == null || g.observe(t);
    })), n();
  }), u && !d && f.observe(u), f.observe(t));
  let v, T = d ? it(e) : null;
  d && $();
  function $() {
    const E = it(e);
    T && !uo(T, E) && n(), T = E, v = requestAnimationFrame($);
  }
  return n(), () => {
    var E;
    m.forEach((x) => {
      i && x.removeEventListener("scroll", n), r && x.removeEventListener("resize", n);
    }), c?.(), (E = f) == null || E.disconnect(), f = null, d && cancelAnimationFrame(v);
  };
}
const Mi = ei, Ai = ti, Bi = Jo, Ri = Ko, Di = ni, Li = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Ti,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return _o(e, t, {
    ...i,
    platform: r
  });
};
function Ni(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function xn(e) {
  if (Ni(e)) {
    const t = e.$el;
    return Mn(t) && lt(t) === "#comment" ? null : t;
  }
  return e;
}
function at(e) {
  return typeof e == "function" ? e() : h(e);
}
function Pi(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = xn(at(e.element));
      return n == null ? {} : Ri({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function co(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zn(e, t) {
  const n = co(e);
  return Math.round(t * n) / n;
}
function Vi(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = k(() => {
    var C;
    return (C = at(n.open)) != null ? C : !0;
  }), r = k(() => at(n.middleware)), l = k(() => {
    var C;
    return (C = at(n.placement)) != null ? C : "bottom";
  }), s = k(() => {
    var C;
    return (C = at(n.strategy)) != null ? C : "absolute";
  }), d = k(() => {
    var C;
    return (C = at(n.transform)) != null ? C : !0;
  }), u = k(() => xn(e.value)), m = k(() => xn(t.value)), c = M(0), a = M(0), f = M(s.value), v = M(l.value), T = wo({}), $ = M(!1), E = k(() => {
    const C = {
      position: f.value,
      left: "0",
      top: "0"
    };
    if (!m.value)
      return C;
    const B = Zn(m.value, c.value), O = Zn(m.value, a.value);
    return d.value ? {
      ...C,
      transform: "translate(" + B + "px, " + O + "px)",
      ...co(m.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: f.value,
      left: B + "px",
      top: O + "px"
    };
  });
  let x;
  function g() {
    if (u.value == null || m.value == null)
      return;
    const C = i.value;
    Li(u.value, m.value, {
      middleware: r.value,
      placement: l.value,
      strategy: s.value
    }).then((B) => {
      c.value = B.x, a.value = B.y, f.value = B.strategy, v.value = B.placement, T.value = B.middlewareData, $.value = C !== !1;
    });
  }
  function y() {
    typeof x == "function" && (x(), x = void 0);
  }
  function S() {
    if (y(), o === void 0) {
      g();
      return;
    }
    if (u.value != null && m.value != null) {
      x = o(u.value, m.value, g);
      return;
    }
  }
  function b() {
    i.value || ($.value = !1);
  }
  return ce([r, l, s, i], g, {
    flush: "sync"
  }), ce([u, m], S, {
    flush: "sync"
  }), ce(i, b, {
    flush: "sync"
  }), Co() && $o(y), {
    x: st(c),
    y: st(a),
    strategy: st(f),
    placement: st(v),
    middlewareData: st(T),
    isPositioned: st($),
    floatingStyles: E,
    update: g
  };
}
const je = /* @__PURE__ */ ae({
  __name: "FloatingMenu",
  props: {
    referenceEl: {},
    placement: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = k(() => n.referenceEl), r = M(null), l = M(null), { floatingStyles: s, middlewareData: d, placement: u } = Vi(i, r, {
      placement: n.placement || "bottom-start",
      middleware: [
        Mi(12),
        Bi(),
        Ai({ padding: 8, limiter: Di() }),
        Pi({ element: l })
      ],
      whileElementsMounted: ki
    }), m = k(() => {
      const v = u.value.split("-")[0];
      return {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      }[v] || "top";
    }), c = k(() => {
      const v = u.value.split("-")[0];
      return {
        top: "rotate(225deg)",
        bottom: "rotate(45deg)",
        left: "rotate(315deg)",
        right: "rotate(135deg)"
      }[v] || "rotate(45deg)";
    }), a = k(() => {
      const v = u.value.split("-")[0];
      return {
        top: "border-b border-r",
        bottom: "border-t border-l",
        left: "border-t border-r",
        right: "border-b border-l"
      }[v] || "border-t border-l";
    });
    Oo(r, (v) => {
      if (n.referenceEl && (v.target === n.referenceEl || n.referenceEl.contains(v.target)))
        return;
      const $ = v.target.closest(".z-101");
      $ && $ !== r.value && !(n.referenceEl && $.contains(n.referenceEl)) || o("close");
    });
    function f(v) {
      v.key === "Escape" && o("close");
    }
    return vt(() => {
      document.addEventListener("keydown", f);
    }), Sn(() => {
      document.removeEventListener("keydown", f);
    }), (v, T) => (w(), oe(Jn, { to: "body" }, [
      p("div", {
        ref_key: "floating",
        ref: r,
        style: ze(h(s)),
        class: "z-101 bg-white rounded-xl shadow-lg border border-slate-200"
      }, [
        In(v.$slots, "default"),
        p("div", {
          ref_key: "floatingArrow",
          ref: l,
          style: ze({
            position: "absolute",
            left: h(d).arrow?.x != null ? `${h(d).arrow.x}px` : "",
            top: h(d).arrow?.y != null ? `${h(d).arrow.y}px` : "",
            [m.value]: "-4px",
            transform: c.value
          }),
          class: J(["w-2 h-2 bg-white border-slate-200", a.value])
        }, null, 6)
      ], 4)
    ]));
  }
}), Oi = { class: "flex items-center gap-3 mb-4" }, Hi = { class: "text-lg font-semibold text-slate-900" }, Fi = { class: "text-sm text-slate-600 mb-6" }, zi = { class: "flex justify-end gap-3" }, Zi = /* @__PURE__ */ ae({
  __name: "ConfirmDialog",
  props: {
    show: { type: Boolean },
    title: {},
    message: {},
    variant: { default: "danger" },
    confirmText: { default: "Confirm" },
    cancelText: { default: "Cancel" }
  },
  emits: ["confirm", "cancel"],
  setup(e) {
    const t = e, n = k(() => {
      switch (t.variant) {
        case "danger":
          return "bg-red-600 hover:bg-red-700";
        case "warning":
          return "bg-orange-600 hover:bg-orange-700";
        case "info":
          return "bg-blue-600 hover:bg-blue-700";
        default:
          return "bg-red-600 hover:bg-red-700";
      }
    });
    return (o, i) => (w(), oe(Jn, { to: "body" }, [
      e.show ? (w(), A("div", {
        key: 0,
        class: "fixed inset-0 z-101 flex items-center justify-center bg-black/50",
        onClick: i[3] || (i[3] = (r) => o.$emit("cancel"))
      }, [
        p("div", {
          class: "bg-white rounded-xl shadow-xl p-6 max-w-md mx-4",
          onClick: i[2] || (i[2] = Se(() => {
          }, ["stop"]))
        }, [
          p("div", Oi, [
            p("h3", Hi, ne(e.title), 1)
          ]),
          p("p", Fi, ne(e.message), 1),
          p("div", zi, [
            p("button", {
              class: "px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-lg transition-colors",
              onClick: i[0] || (i[0] = (r) => o.$emit("cancel"))
            }, ne(e.cancelText), 1),
            p("button", {
              class: J(["px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors", n.value]),
              onClick: i[1] || (i[1] = (r) => o.$emit("confirm"))
            }, ne(e.confirmText), 3)
          ])
        ])
      ])) : q("", !0)
    ]));
  }
}), ji = {}, Ui = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Wi(e, t) {
  return w(), A("svg", Ui, [...t[0] || (t[0] = [
    p("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.0001 2.09961C7.3867 2.09961 7.7001 2.41301 7.7001 2.79961V6.29961H11.2001C11.5867 6.29961 11.9001 6.61301 11.9001 6.99961C11.9001 7.38621 11.5867 7.69961 11.2001 7.69961H7.7001V11.1996C7.7001 11.5862 7.3867 11.8996 7.0001 11.8996C6.6135 11.8996 6.3001 11.5862 6.3001 11.1996V7.69961H2.8001C2.4135 7.69961 2.1001 7.38621 2.1001 6.99961C2.1001 6.61301 2.4135 6.29961 2.8001 6.29961L6.3001 6.29961V2.79961C6.3001 2.41301 6.6135 2.09961 7.0001 2.09961Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const wt = /* @__PURE__ */ ge(ji, [["render", Wi]]), qi = ["for"], Xi = { class: "space-y-2" }, Gi = ["onClick"], Yi = ["id", "placeholder", "onKeydown"], _i = { class: "p-2 w-90 max-h-40 overflow-y-auto" }, Ki = ["disabled", "onClick"], Ji = {
  key: 1,
  class: "px-3 py-2 text-sm text-slate-400 text-center"
}, jn = /* @__PURE__ */ ae({
  __name: "CriteriaEditor",
  props: {
    modelValue: {},
    globalOptions: {},
    type: {},
    label: {},
    placeholder: {},
    emptyMessage: {}
  },
  emits: ["update:modelValue", "add", "remove"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = M(""), r = M(!1), l = M(null), s = k(() => n.type === "inclusion" ? "border border-green-200 bg-green-50/50" : "border border-red-200 bg-red-50/50"), d = k(() => n.type === "inclusion" ? "hover:bg-green-50 text-green-600" : "hover:bg-red-50 text-red-600"), u = k(() => {
      const a = i.value.toLowerCase();
      return n.globalOptions.filter(
        (f) => f.toLowerCase().includes(a) && !n.modelValue.includes(f)
      );
    });
    function m() {
      i.value && !n.modelValue.includes(i.value) && (o("add", i.value), i.value = "");
    }
    function c(a) {
      n.modelValue.includes(a) || (o("update:modelValue", [...n.modelValue, a]), i.value = "");
    }
    return (a, f) => (w(), A("div", null, [
      p("label", {
        for: `${e.type}-input`,
        class: "block text-sm font-medium text-slate-700 mb-1"
      }, ne(e.label), 9, qi),
      p("div", Xi, [
        (w(!0), A(de, null, pe(e.modelValue, (v, T) => (w(), A("div", {
          key: `${e.type}-${T}`,
          class: "flex items-center gap-2"
        }, [
          p("span", {
            class: J(["flex-1 h-9 rounded-lg px-3 text-sm flex items-center", s.value])
          }, ne(v), 3),
          p("button", {
            class: "text-red-400 hover:text-red-600 transition-colors",
            onClick: ($) => a.$emit("remove", T)
          }, [
            Q(zt)
          ], 8, Gi)
        ]))), 128)),
        p("div", null, [
          ke(p("input", {
            id: `${e.type}-input`,
            ref_key: "inputRef",
            ref: l,
            "onUpdate:modelValue": f[0] || (f[0] = (v) => i.value = v),
            type: "text",
            class: "h-9 w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
            placeholder: e.placeholder,
            onFocus: f[1] || (f[1] = (v) => r.value = !0),
            onKeydown: nt(Se(m, ["prevent"]), ["enter"])
          }, null, 40, Yi), [
            [Ze, i.value]
          ]),
          r.value && (u.value.length > 0 || i.value) ? (w(), oe(je, {
            key: 0,
            "reference-el": l.value,
            onClose: f[2] || (f[2] = (v) => r.value = !1)
          }, {
            default: Pe(() => [
              p("div", _i, [
                i.value && !e.globalOptions.includes(i.value) ? (w(), A("button", {
                  key: 0,
                  type: "button",
                  class: J(["w-full px-3 py-2 text-left text-sm rounded flex items-center gap-2", d.value]),
                  onClick: m
                }, [
                  Q(wt),
                  Qn(' Create "' + ne(i.value) + '" ', 1)
                ], 2)) : q("", !0),
                (w(!0), A(de, null, pe(u.value, (v) => (w(), A("button", {
                  key: v,
                  type: "button",
                  class: J(["w-full px-3 py-2 text-left text-sm hover:bg-slate-50 rounded", { "opacity-50": e.modelValue.includes(v) }]),
                  disabled: e.modelValue.includes(v),
                  onClick: (T) => c(v)
                }, ne(v), 11, Ki))), 128)),
                i.value && e.globalOptions.includes(i.value) && u.value.length === 0 ? (w(), A("div", Ji, ne(e.emptyMessage), 1)) : q("", !0)
              ])
            ]),
            _: 1
          }, 8, ["reference-el"])) : q("", !0)
        ])
      ])
    ]));
  }
});
var fe = /* @__PURE__ */ ((e) => (e.EXACT = "exact", e.BETWEEN = "between", e))(fe || {});
const $e = [
  {
    outer: "bg-orange-400",
    inner: "bg-orange-600",
    line: "bg-orange-600",
    arrow: "border-l-orange-600",
    interventionName: "text-orange-600",
    interventionBg: "bg-orange-100"
  },
  {
    outer: "bg-blue-400",
    inner: "bg-blue-600",
    line: "bg-blue-600",
    arrow: "border-l-blue-600",
    interventionName: "text-blue-600",
    interventionBg: "bg-blue-100"
  },
  {
    outer: "bg-green-400",
    inner: "bg-green-600",
    line: "bg-green-600",
    arrow: "border-l-green-600",
    interventionName: "text-green-600",
    interventionBg: "bg-green-100"
  },
  {
    outer: "bg-purple-400",
    inner: "bg-purple-600",
    line: "bg-purple-600",
    arrow: "border-l-purple-600",
    interventionName: "text-purple-600",
    interventionBg: "bg-purple-100"
  },
  {
    outer: "bg-pink-400",
    inner: "bg-pink-600",
    line: "bg-pink-600",
    arrow: "border-l-pink-600",
    interventionName: "text-pink-600",
    interventionBg: "bg-pink-100"
  },
  {
    outer: "bg-teal-400",
    inner: "bg-teal-600",
    line: "bg-teal-600",
    arrow: "border-l-teal-600",
    interventionName: "text-teal-600",
    interventionBg: "bg-teal-100"
  },
  {
    outer: "bg-amber-400",
    inner: "bg-amber-600",
    line: "bg-amber-600",
    arrow: "border-l-amber-600",
    interventionName: "text-amber-600",
    interventionBg: "bg-amber-100"
  },
  {
    outer: "bg-cyan-400",
    inner: "bg-cyan-600",
    line: "bg-cyan-600",
    arrow: "border-l-cyan-600",
    interventionName: "text-cyan-600",
    interventionBg: "bg-cyan-100"
  }
];
function Qi(e = {}) {
  const t = e.baselineName ?? "Baseline", n = M(e.populations ?? []), o = M(e.arms ?? []), i = M(e.exposures ?? []), r = M(
    (e.interventions ?? []).map((f) => ({
      ...f,
      timepoints: f.timepoints.map(
        (v) => v.isBaseline ? { ...v, name: t } : v
      )
    }))
  ), l = M(e.globalCriteria ?? []), s = M(e.globalCharacteristics ?? []), d = M(t), u = M(null), m = M(e.mode ?? "edit"), c = M([]), a = M([]);
  return {
    populationsDataEntity: n,
    armsDataEntity: o,
    exposuresDataEntity: i,
    interventionsDataEntity: r,
    hoveredTimepointId: u,
    globalCriteria: l,
    globalCharacteristics: s,
    baselineName: d,
    mode: m,
    selectedTimepointNames: c,
    selectedInterventionIds: a
  };
}
function el(e, t) {
  return e.includes(t) ? e : [...e, t];
}
function tl(e, t) {
  return e.includes(t) ? e : [...e, t];
}
const Un = [
  "#0ea5e9",
  "#3b82f6",
  "#1e40af",
  "#60a5fa",
  "#0284c7",
  "#6366f1",
  "#075985",
  "#93c5fd",
  "#2563eb",
  "#4f46e5"
];
function vo(e) {
  return Un[e % Un.length];
}
function nl(e) {
  return `P${e + 1}`;
}
function Wn(e) {
  return `G${e + 1}`;
}
function ol(e, t) {
  return [...e, t];
}
function il(e, t, n) {
  return e.map((o) => o.id === t ? { ...o, ...n } : o);
}
function ll(e, t) {
  return e.find((n) => n.id === t);
}
function fo(e, t) {
  const n = e.findIndex((o) => o.id === t);
  return n >= 0 ? n % $e.length : 0;
}
const Ce = "abcdefghijklmnopqrstuvwxyz", Dt = 13;
function po(e, t) {
  if (e === null && t === null)
    return Ce[Dt];
  if (e === null && t !== null) {
    const s = t.charAt(0), d = Ce.indexOf(s);
    return d > 0 ? Ce[Math.floor(d / 2)] : "a" + Ce[Dt];
  }
  if (t === null && e !== null) {
    const s = e.charAt(e.length - 1), d = Ce.indexOf(s);
    return d < Ce.length - 1 ? e.slice(0, -1) + Ce[Math.floor((d + Ce.length) / 2)] : e + Ce[Dt];
  }
  let n = 0;
  for (; n < e.length && n < t.length && e[n] === t[n]; )
    n++;
  const o = n < e.length ? e[n] : "a", i = n < t.length ? t[n] : "z", r = Ce.indexOf(o), l = Ce.indexOf(i);
  return l - r > 1 ? e.slice(0, n) + Ce[Math.floor((r + l) / 2)] : e.slice(0, n + 1) + Ce[Dt];
}
function rl(e, t) {
  const n = t.filter((r) => !r.isStart && !r.isEnd && !r.isBaseline).sort((r, l) => r.order.localeCompare(l.order)), o = n.findIndex((r) => r.order > e);
  return `Mid ${(o === -1 ? n.length : o) + 1}`;
}
function sl(e, t, n, o, i) {
  const r = e.find((s) => s.id === t);
  if (!r) return e;
  const l = r.timepoints.find((s) => s.id === n);
  if (!l || l.isBaseline)
    return e;
  if (i) {
    const s = l.name;
    return e.map((d) => ({
      ...d,
      timepoints: d.timepoints.map(
        (u) => u.name === s && !u.isBaseline ? { ...u, name: o } : u
      )
    }));
  }
  return e.map(
    (s) => s.id === t ? {
      ...s,
      timepoints: s.timepoints.map(
        (d) => d.id === n ? { ...d, name: o } : d
      )
    } : s
  );
}
function al(e, t, n, o = () => Date.now().toString()) {
  const i = e.find((v) => v.id === t);
  if (!i) return e;
  const r = i.timepoints.filter((v) => !v.isBaseline), l = [...r].sort(
    (v, T) => v.order.localeCompare(T.order)
  ), s = i.timepoints.find((v) => v.isBaseline);
  if (r.length === 1) {
    const T = l[0]?.participantCount ?? s?.participantCount, $ = {
      id: o(),
      name: "End",
      order: "z",
      isEnd: !0,
      participantCount: T
    };
    return e.map(
      (E) => E.id === t ? { ...E, timepoints: [...E.timepoints, $] } : E
    );
  }
  let d = null, u = null, m;
  if (n === null)
    u = l.length > 0 ? l[0].order : null;
  else {
    const v = l.findIndex((T) => T.id === n);
    v >= 0 && (d = l[v].order, m = l[v], u = v + 1 < l.length ? l[v + 1].order : null);
  }
  const c = po(d, u), a = rl(c, i.timepoints), f = {
    id: o(),
    name: a,
    order: c,
    participantCount: m?.participantCount
  };
  return e.map(
    (v) => v.id === t ? { ...v, timepoints: [...v.timepoints, f] } : v
  );
}
function ul(e, t, n) {
  const o = e.find((l) => l.id === t);
  if (!o)
    return { interventions: e, removed: !1, reason: "Intervention not found" };
  const i = o.timepoints.find((l) => l.id === n);
  return i ? i.isStart ? { interventions: e, removed: !1, reason: "Cannot remove start timepoint" } : i.isEnd && o.timepoints.some((l) => !l.isStart && !l.isEnd && !l.isBaseline) ? {
    interventions: e,
    removed: !1,
    reason: "Cannot remove end timepoint when middle timepoints exist"
  } : { interventions: e.map(
    (l) => l.id === t ? { ...l, timepoints: l.timepoints.filter((s) => s.id !== n) } : l
  ), removed: !0 } : { interventions: e, removed: !1, reason: "Timepoint not found" };
}
function mo(e, t) {
  return e.filter((n) => n.armId === t).sort((n, o) => n.order.localeCompare(o.order));
}
function cl(e, t, n, o) {
  const i = o?.idGenerator ?? (() => Date.now().toString()), r = mo(e, t);
  let l = null, s = null;
  if (o?.afterInterventionId) {
    const f = r.find((v) => v.id === o.afterInterventionId);
    if (f) {
      const v = r.indexOf(f);
      l = f.order, s = v + 1 < r.length ? r[v + 1].order : null;
    }
  } else
    l = r[r.length - 1]?.order ?? null;
  const d = po(l, s), u = r.length === 0, m = {
    id: i() + "-baseline",
    name: o?.baselineName ?? "Baseline",
    order: "0",
    isBaseline: !0
  }, c = {
    id: i() + "-start",
    name: "Start",
    order: "a",
    isStart: !0
  }, a = {
    id: i(),
    armId: t,
    exposureIds: n,
    order: d,
    timepoints: u ? [m, c] : [c]
  };
  return {
    interventions: [...e, a],
    newIntervention: a
  };
}
function dl(e, t) {
  return e.filter((n) => n.id !== t);
}
function vl(e, t, n) {
  return e.map((o) => o.id === t ? { ...o, ...n } : o);
}
function fl(e) {
  const {
    populationsDataEntity: t,
    armsDataEntity: n,
    exposuresDataEntity: o,
    interventionsDataEntity: i,
    selectedTimepointNames: r
  } = e, l = k(() => t.value.map((f, v) => {
    const T = n.value.filter(($) => $.populationId === f.id).map(($) => ({
      id: $.id,
      name: $.name,
      participantsCount: $.participantsCount,
      populationId: $.populationId
    }));
    return {
      id: f.id,
      name: f.name,
      color: vo(v),
      arms: T.length > 0 ? T : void 0,
      inclusionCriteria: f.inclusionCriteria,
      exclusionCriteria: f.exclusionCriteria,
      isRandomized: f.isRandomized
    };
  })), s = k(() => o.value), d = k(() => i.value);
  function u(f) {
    return n.value.filter((T) => T.populationId === f).reduce((T, $) => T + $.participantsCount, 0);
  }
  const m = k(() => {
    const { selectedInterventionIds: f } = e;
    if (r.value.length === 0 || f.value.length === 0) return null;
    const v = f.value[0];
    return v ? i.value.find(($) => $.id === v)?.armId ?? null : null;
  }), c = k(() => {
    const { selectedInterventionIds: f } = e;
    return r.value.length === 0 || f.value.length === 0 ? null : f.value[0] ?? null;
  }), a = k(() => {
    const { selectedInterventionIds: f } = e;
    if (f.value.length === 0) return [];
    const v = i.value.filter(
      (E) => f.value.includes(E.id)
    );
    if (v.length === 0) return [];
    if (v.length === 1)
      return v[0].timepoints.map((E) => E.name);
    const T = v[0].timepoints.map((E) => E.name), $ = v.slice(1).map((E) => E.timepoints.map((x) => x.name));
    return T.filter(
      (E) => $.every((x) => x.includes(E))
    );
  });
  return {
    populations: l,
    exposures: s,
    interventions: d,
    getPopulationParticipantsCount: u,
    armIdWithSelectedTimepoints: m,
    interventionIdWithSelectedTimepoints: c,
    commonTimepointNamesInSelectedInterventions: a
  };
}
const Re = {
  lifecycle: "color: #06b6d4; font-weight: bold; font-size: 14px",
  user: "color: #a855f7; font-weight: bold",
  state: {
    add: "color: #10b981; font-weight: bold",
    remove: "color: #ef4444; font-weight: bold",
    update: "color: #3b82f6; font-weight: bold",
    reset: "color: #dc2626; font-weight: bold; font-size: 14px",
    create: "color: #f59e0b; font-weight: bold",
    duplicate: "color: #8b5cf6; font-weight: bold"
  },
  computed: "color: #06b6d4; font-weight: bold"
}, V = {
  lifecycle(e, t) {
    t ? console.log(`%c[VDB:Lifecycle] 🚀 ${e}`, Re.lifecycle, t) : console.log(`%c[VDB:Lifecycle] 🚀 ${e}`, Re.lifecycle);
  },
  user(e, t) {
    t ? console.log(`%c[VDB:User] ${e}`, Re.user, t) : console.log(`%c[VDB:User] ${e}`, Re.user);
  },
  state: {
    add(e, t) {
      console.log(`%c[VDB:State] ${e}`, Re.state.add, t);
    },
    remove(e, t) {
      console.log(`%c[VDB:State] ${e}`, Re.state.remove, t);
    },
    update(e, t) {
      console.log(`%c[VDB:State] ${e}`, Re.state.update, t);
    },
    reset(e, t) {
      console.log(`%c[VDB:State] 🔄 ${e}`, Re.state.reset, t);
    },
    create(e, t) {
      console.log(`%c[VDB:State] ${e}`, Re.state.create, t);
    },
    duplicate(e, t) {
      console.log(`%c[VDB:State] ${e}`, Re.state.duplicate, t);
    },
    warn(e, t) {
      console.warn(`[VDB:State] ${e}`, t);
    }
  },
  computed(e, t) {
    console.log(`%c[VDB:Computed] ${e}`, Re.computed, t);
  }
}, qn = {
  now: () => Date.now().toString()
};
function pl(e) {
  const {
    populationsDataEntity: t,
    armsDataEntity: n,
    exposuresDataEntity: o,
    interventionsDataEntity: i,
    hoveredTimepointId: r,
    globalCriteria: l,
    globalCharacteristics: s,
    baselineName: d,
    selectedTimepointNames: u,
    selectedInterventionIds: m
  } = e;
  function c(I) {
    s.value = tl(
      s.value,
      I
    );
  }
  function a(I) {
    l.value = el(l.value, I);
  }
  function f(I, L, D, N) {
    const G = i.value.find((K) => K.id === I);
    if (!G) return;
    const W = G.timepoints.find((K) => K.id === L);
    W && (V.state.update("Renaming timepoint", {
      oldName: W.name,
      newName: D,
      interventionId: I,
      timepointId: L,
      applyToAll: N
    }), i.value = sl(
      i.value,
      I,
      L,
      D,
      N
    ));
  }
  function v(I) {
    I !== r.value && V.user("Timepoint hover changed", {
      timepointId: I
    }), r.value = I;
  }
  function T(I) {
    const L = { ...I };
    if (!L.name) {
      const N = t.value.length;
      L.name = nl(N);
    }
    V.state.add("Adding population", {
      id: L.id,
      name: L.name,
      totalPopulations: t.value.length + 1
    });
    const D = {
      id: `${L.id}-arm-1`,
      name: Wn(0),
      participantsCount: 0,
      populationId: L.id
    };
    V.state.add("Auto-creating default arm for new population", {
      populationId: L.id,
      armId: D.id
    }), t.value = [...t.value, L], n.value = [...n.value, D];
  }
  function $(I) {
    const L = { ...I };
    if (!L.name) {
      const D = n.value.filter(
        (N) => N.populationId === L.populationId
      ).length;
      L.name = Wn(D);
    }
    V.state.add("Adding arm", {
      id: L.id,
      name: L.name,
      populationId: L.populationId,
      participantsCount: L.participantsCount
    }), n.value = [...n.value, L];
  }
  function E(I) {
    if (!t.value.find((N) => N.id === I)) return;
    const D = n.value.filter((N) => N.populationId === I).map((N) => N.id);
    V.state.remove("Removing population", {
      id: I,
      armIds: D
    }), t.value = t.value.filter((N) => N.id !== I), n.value = n.value.filter((N) => N.populationId !== I), i.value = i.value.filter(
      (N) => !D.includes(N.armId)
    );
  }
  function x(I) {
    const L = n.value.find((N) => N.id === I);
    if (!L) return;
    if (n.value.filter(
      (N) => N.populationId === L.populationId
    ).length <= 1) {
      V.state.warn("Cannot remove last arm of population", {
        armId: I,
        populationId: L.populationId
      });
      return;
    }
    V.state.remove("Removing arm", {
      armId: I,
      populationId: L.populationId
    }), n.value = n.value.filter((N) => N.id !== I), i.value = i.value.filter((N) => N.armId !== I);
  }
  function g(I, L) {
    const D = t.value.find((N) => N.id === I);
    if (!D) {
      V.state.warn("Population not found for update:", { id: I });
      return;
    }
    V.state.update("Updating population", {
      id: I,
      updates: L,
      before: { ...D }
    }), t.value = t.value.map(
      (N) => N.id === I ? { ...N, ...L } : N
    );
  }
  function y(I, L) {
    const D = n.value.find((N) => N.id === I);
    if (!D) {
      V.state.warn("Arm not found for update:", { armId: I });
      return;
    }
    V.state.update("Updating arm", {
      armId: I,
      updates: L,
      before: { ...D }
    }), n.value = n.value.map(
      (N) => N.id === I ? { ...N, ...L } : N
    );
  }
  function S(I, L) {
    V.state.update("Updating global baseline name", {
      newBaselineName: L
    }), d.value = L, i.value = i.value.map((D) => ({
      ...D,
      timepoints: D.timepoints.map(
        (N) => N.isBaseline ? { ...N, name: L } : N
      )
    }));
  }
  function b(I) {
    return t.value.find((L) => L.id === I);
  }
  function C(I) {
    return n.value.find((L) => L.id === I);
  }
  function B(I, L, D) {
    const N = [...L].sort((W, K) => W.localeCompare(K)), G = [...D].sort((W, K) => W.localeCompare(K));
    return t.value.find((W) => {
      if (W.id === I) return !1;
      const K = [...W.inclusionCriteria ?? []].sort((ye, we) => ye.localeCompare(we)), Be = [...W.exclusionCriteria ?? []].sort((ye, we) => ye.localeCompare(we)), he = K.length === N.length && K.every((ye, we) => ye === N[we]), We = Be.length === G.length && Be.every((ye, we) => ye === G[we]);
      return he && We;
    });
  }
  function O(I, L) {
    const D = b(I), N = b(L);
    if (!D || !N) {
      V.state.warn("Cannot merge: population not found", {
        sourcePopulationId: I,
        targetPopulationId: L
      });
      return;
    }
    const G = n.value.filter((W) => W.populationId === I);
    V.state.update("Merging populations", {
      sourceId: I,
      targetId: L,
      armsToMove: G.length
    }), n.value = n.value.map(
      (W) => W.populationId === I ? { ...W, populationId: L } : W
    ), E(I);
  }
  function P(I) {
    return mo(i.value, I);
  }
  function U(I, L, D) {
    const N = C(I), G = P(I).length === 0, W = cl(i.value, I, L, {
      afterInterventionId: D,
      idGenerator: qn.now,
      baselineName: d.value
    });
    if (G && N && N.participantsCount > 0 && W.newIntervention.timepoints.some((Be) => Be.isBaseline)) {
      const Be = W.newIntervention.timepoints.map(
        (he) => he.isBaseline || he.isStart ? { ...he, participantCount: N.participantsCount } : he
      );
      W.newIntervention = { ...W.newIntervention, timepoints: Be }, W.interventions = W.interventions.map(
        (he) => he.id === W.newIntervention.id ? W.newIntervention : he
      );
    }
    return V.state.add("Adding intervention", {
      interventionId: W.newIntervention.id,
      armId: I,
      exposureIds: L,
      order: W.newIntervention.order,
      afterInterventionId: D,
      timepointsCount: W.newIntervention.timepoints.length
    }), i.value = W.interventions, W.newIntervention;
  }
  function _(I) {
    const L = i.value.find((D) => D.id === I);
    L && (V.state.remove("Removing intervention", {
      interventionId: I,
      armId: L.armId,
      exposureIds: L.exposureIds,
      timepointsCount: L.timepoints.length
    }), i.value = dl(
      i.value,
      I
    ));
  }
  function z(I, L) {
    i.value = vl(
      i.value,
      I,
      L
    );
  }
  function X(I, L) {
    const D = i.value.find((W) => W.id === I);
    if (!D) return;
    const N = D.timepoints.length;
    i.value = al(
      i.value,
      I,
      L,
      qn.now
    );
    const G = i.value.find((W) => W.id === I);
    if (G && G.timepoints.length > N) {
      const W = G.timepoints[G.timepoints.length - 1];
      V.state.add("Adding timepoint to intervention", {
        interventionId: I,
        timepointId: W?.id,
        timepointName: W?.name,
        afterTimepointId: L,
        totalTimepoints: G.timepoints.length
      });
    }
  }
  function ee(I, L) {
    const D = i.value.find((W) => W.id === I);
    if (!D) return;
    const N = D.timepoints.find((W) => W.id === L);
    if (!N) return;
    const G = ul(
      i.value,
      I,
      L
    );
    if (!G.removed) {
      V.state.warn(G.reason ?? "Cannot remove timepoint", {
        timepointId: L,
        timepoint: N
      });
      return;
    }
    V.state.remove("Removing timepoint from intervention", {
      interventionId: I,
      timepointId: L,
      timepointName: N.name,
      remainingTimepoints: D.timepoints.length - 1
    }), i.value = G.interventions;
  }
  function le(I) {
    V.state.add("Adding exposure", {
      id: I.id,
      name: I.name,
      characteristicsCount: I.characteristics.length,
      totalExposures: o.value.length + 1
    }), o.value = ol(o.value, I);
  }
  function ie(I) {
    return fo(o.value, I);
  }
  function te(I, L) {
    const D = o.value.find((N) => N.id === I);
    D ? (V.state.update("Updating exposure", {
      id: I,
      updates: L,
      before: { ...D }
    }), o.value = il(o.value, I, L)) : V.state.warn("Exposure not found for update:", { id: I });
  }
  function re(I) {
    return ll(o.value, I);
  }
  function me() {
    V.state.reset("RESET ALL", {
      populations: t.value.length,
      arms: n.value.length,
      exposures: o.value.length,
      interventions: i.value.length
    }), t.value = [], n.value = [], o.value = [], i.value = [], r.value = null, l.value = [], s.value = [], d.value = "Baseline", u.value = [], m.value = [];
  }
  function Me(I) {
    V.state.update("Importing study design", {
      populations: I.populations?.length ?? 0,
      arms: I.arms?.length ?? 0,
      exposures: I.exposures?.length ?? 0,
      interventions: I.interventions?.length ?? 0
    }), t.value = I.populations ?? [], n.value = I.arms ?? [], o.value = I.exposures ?? [], i.value = I.interventions ?? [], l.value = I.globalCriteria ?? [], s.value = I.globalCharacteristics ?? [], d.value = I.baselineName ?? "Baseline", u.value = [], m.value = [];
  }
  function se(I, L) {
    if (!i.value.find((W) => W.id === I)) return;
    const N = u.value.includes(L), G = m.value.includes(I);
    if (N && G) {
      be(I, L);
      return;
    }
    !N && u.value.length < 2 && (u.value = [...u.value, L]), !G && m.value.length < 2 && (m.value = [...m.value, I]);
  }
  function be(I, L) {
    const D = m.value.length === 2, N = u.value.length === 2;
    if (D && N) {
      u.value = u.value.filter(
        (G) => G !== L
      );
      return;
    }
    u.value = u.value.filter(
      (G) => G !== L
    ), u.value.length === 0 && (m.value = []);
  }
  function ue(I) {
    if (m.value.includes(I)) {
      m.value = m.value.filter(
        (D) => D !== I
      ), m.value.length === 0 && (u.value = []);
      return;
    }
    u.value.length !== 0 && (m.value.length >= 2 || (m.value = [...m.value, I]));
  }
  function He() {
    u.value = [], m.value = [];
  }
  function Ae() {
    return {
      timepointNames: u.value,
      interventionIds: m.value
    };
  }
  return {
    addGlobalCharacteristic: c,
    addGlobalCriterion: a,
    setHoveredTimepoint: v,
    updateTimepointName: f,
    addPopulation: T,
    removePopulation: E,
    updatePopulation: g,
    getPopulationById: b,
    findPopulationWithSameCriteria: B,
    mergePopulations: O,
    addArm: $,
    removeArm: x,
    updateArm: y,
    updateArmBaselineName: S,
    getArmById: C,
    getInterventionsForArm: P,
    addIntervention: U,
    removeIntervention: _,
    updateIntervention: z,
    addTimepointToIntervention: X,
    removeTimepointFromIntervention: ee,
    addExposure: le,
    getExposureColorIndex: ie,
    updateExposure: te,
    getExposureById: re,
    resetAll: me,
    importStudyDesign: Me,
    toggleTimepointSelection: se,
    toggleInterventionSelection: ue,
    clearSelection: He,
    getSelection: Ae
  };
}
function ml(e, t) {
  const n = So(e, t);
  if (n === void 0)
    throw new Error(
      `[VDB] Missing required injection: "${String(e.description ?? e)}". Make sure the VisualStudyDesignBuilder component is an ancestor of this component.`
    );
  return n;
}
function gl(e = {}) {
  const t = Qi(e), n = fl(t), o = pl(t);
  return {
    ...n,
    ...t,
    ...o
  };
}
const go = /* @__PURE__ */ Symbol(
  "VisualStudyDesignBuilderContext"
);
function Ue() {
  return ml(go);
}
const hl = { class: "p-4 w-100 space-y-4" }, xl = { class: "flex gap-2 pt-2" }, bl = /* @__PURE__ */ ae({
  __name: "PopulationMenu",
  props: {
    populationId: {},
    referenceEl: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      getPopulationById: i,
      updatePopulation: r,
      globalCriteria: l,
      addGlobalCriterion: s,
      findPopulationWithSameCriteria: d,
      mergePopulations: u
    } = Ue(), m = M(""), c = M([]), a = M([]), f = M(null), v = M(!1), T = M(null), $ = M(""), E = k(() => i(n.populationId));
    function x() {
      if (!E.value) return;
      f.value = null;
      const P = d(
        n.populationId,
        c.value,
        a.value
      );
      if (P) {
        T.value = P.id, $.value = P.name, v.value = !0;
        return;
      }
      g();
    }
    function g() {
      const P = {
        name: m.value,
        inclusionCriteria: c.value,
        exclusionCriteria: a.value
      };
      r(n.populationId, P), o("close");
    }
    function y() {
      T.value && (u(n.populationId, T.value), v.value = !1, o("close"));
    }
    function S() {
      v.value = !1, g();
    }
    function b(P) {
      P && !c.value.includes(P) && (c.value.push(P), s(P));
    }
    function C(P) {
      c.value.splice(P, 1);
    }
    function B(P) {
      P && !a.value.includes(P) && (a.value.push(P), s(P));
    }
    function O(P) {
      a.value.splice(P, 1);
    }
    return vt(() => {
      const P = i(n.populationId);
      P && (m.value = P.name, c.value = [...P.inclusionCriteria || []], a.value = [...P.exclusionCriteria || []]);
    }), (P, U) => (w(), A(de, null, [
      Q(je, {
        "reference-el": e.referenceEl,
        onClose: U[4] || (U[4] = (_) => P.$emit("close"))
      }, {
        default: Pe(() => [
          p("div", hl, [
            p("div", null, [
              U[5] || (U[5] = p("label", {
                for: "population-name",
                class: "block text-sm font-medium text-slate-700 mb-1"
              }, "Name", -1)),
              ke(p("input", {
                id: "population-name",
                "onUpdate:modelValue": U[0] || (U[0] = (_) => m.value = _),
                type: "text",
                class: "h-9 w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
                placeholder: "Enter name..."
              }, null, 512), [
                [Ze, m.value]
              ])
            ]),
            Q(jn, {
              modelValue: c.value,
              "onUpdate:modelValue": U[1] || (U[1] = (_) => c.value = _),
              "global-options": h(l),
              type: "inclusion",
              label: "Inclusion Criteria",
              placeholder: "Add or search criteria...",
              "empty-message": "Criteria already added",
              onAdd: b,
              onRemove: C
            }, null, 8, ["modelValue", "global-options"]),
            Q(jn, {
              modelValue: a.value,
              "onUpdate:modelValue": U[2] || (U[2] = (_) => a.value = _),
              "global-options": h(l),
              type: "exclusion",
              label: "Exclusion Criteria",
              placeholder: "Add or search criteria...",
              "empty-message": "Criteria already added",
              onAdd: B,
              onRemove: O
            }, null, 8, ["modelValue", "global-options"]),
            p("div", xl, [
              p("button", {
                class: "flex-1 h-9 rounded-lg bg-blue-600 text-white font-medium text-sm hover:bg-blue-700 transition-colors",
                onClick: x
              }, " Save "),
              p("button", {
                class: "h-9 px-4 rounded-lg border border-slate-200 bg-white text-slate-700 font-medium text-sm hover:bg-slate-50 transition-colors",
                onClick: U[3] || (U[3] = (_) => P.$emit("close"))
              }, " Cancel ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["reference-el"]),
      Q(Zi, {
        show: v.value,
        title: "Merge Populations",
        message: `A population with the same criteria already exists (${$.value}). Do you want to merge the current population into it?`,
        variant: "warning",
        "confirm-text": "Merge",
        "cancel-text": "Keep Separate",
        onConfirm: y,
        onCancel: S
      }, null, 8, ["show", "message"])
    ], 64));
  }
}), yl = {}, wl = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Cl(e, t) {
  return w(), A("svg", wl, [...t[0] || (t[0] = [
    p("path", {
      d: "M0 9V7H7.6L12.6 2H10V0H16V6H14V3.4L8.4 9H0ZM10 16V14H12.6L9.4 10.85L10.85 9.4L14 12.6V10H16V16H10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const $l = /* @__PURE__ */ ge(yl, [["render", Cl]]), Sl = {}, Il = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Tl(e, t) {
  return w(), A("svg", Il, [...t[0] || (t[0] = [
    p("path", {
      d: "M5.206 16.35C5.61807 16.561 6.04219 16.5962 6.47836 16.4554C6.91452 16.3147 7.23812 16.0383 7.44915 15.6262C7.66017 15.2141 7.69532 14.79 7.55459 14.3539C7.41385 13.9177 7.13745 13.5941 6.72538 13.3831C6.31331 13.172 5.88919 13.1369 5.45302 13.2776C5.01685 13.4184 4.69326 13.6948 4.48223 14.1068C4.27121 14.5189 4.23606 14.943 4.37679 15.3792C4.51752 15.8154 4.79393 16.139 5.206 16.35ZM9.76415 7.44923C10.1762 7.66026 10.6003 7.69541 11.0365 7.55467C11.4727 7.41394 11.7963 7.13754 12.0073 6.72547C12.2183 6.3134 12.2535 5.88928 12.1127 5.45311C11.972 5.01694 11.6956 4.69334 11.2835 4.48232C10.8715 4.27129 10.4473 4.23615 10.0112 4.37688C9.575 4.51761 9.25141 4.79401 9.04038 5.20608C8.82935 5.61816 8.79421 6.04228 8.93494 6.47844C9.07567 6.91461 9.35207 7.23821 9.76415 7.44923ZM11.9354 14.1787C12.3475 14.3897 12.7716 14.4249 13.2078 14.2841C13.644 14.1434 13.9676 13.867 14.1786 13.4549C14.3896 13.0428 14.4248 12.6187 14.284 12.1826C14.1433 11.7464 13.8669 11.4228 13.4548 11.2118C13.0428 11.0007 12.6186 10.9656 12.1825 11.1063C11.7463 11.2471 11.4227 11.5235 11.2117 11.9355C11.0007 12.3476 10.9655 12.7717 11.1062 13.2079C11.247 13.6441 11.5234 13.9677 11.9354 14.1787ZM14.1067 20.9081C14.5188 21.1192 14.9429 21.1543 15.3791 21.0136C15.8153 20.8728 16.1389 20.5964 16.3499 20.1844C16.5609 19.7723 16.5961 19.3482 16.4553 18.912C16.3146 18.4758 16.0382 18.1522 15.6261 17.9412C15.2141 17.7302 14.7899 17.695 14.3538 17.8358C13.9176 17.9765 13.594 18.2529 13.383 18.665C13.172 19.0771 13.1368 19.5012 13.2775 19.9373C13.4183 20.3735 13.6947 20.6971 14.1067 20.9081ZM18.6649 12.0074C19.077 12.2184 19.5011 12.2536 19.9373 12.1128C20.3734 11.9721 20.697 11.6957 20.908 11.2836C21.1191 10.8715 21.1542 10.4474 21.0135 10.0113C20.8727 9.57509 20.5963 9.25149 20.1843 9.04047C19.7722 8.82944 19.3481 8.7943 18.9119 8.93503C18.4757 9.07576 18.1522 9.35216 17.9411 9.76423C17.7301 10.1763 17.695 10.6004 17.8357 11.0366C17.9764 11.4728 18.2528 11.7964 18.6649 12.0074ZM1.21419 18.0507C0.670251 17.7722 0.303791 17.3401 0.114808 16.7543C-0.0741757 16.1686 -0.0293901 15.6038 0.249163 15.0599L7.33962 1.21427C7.61817 0.670337 8.0503 0.303878 8.63601 0.114895C9.22173 -0.0740884 9.78655 -0.0293035 10.3305 0.24925L24.1761 7.3397C24.72 7.61826 25.0865 8.05039 25.2755 8.6361C25.4644 9.22181 25.4197 9.78663 25.1411 10.3306L18.0507 24.1762C17.7721 24.7201 17.34 25.0866 16.7543 25.2756C16.1685 25.4645 15.6037 25.4197 15.0598 25.1412L1.21419 18.0507ZM2.22711 16.0728L16.0727 23.1633L23.1632 9.31765L9.31756 2.22719L2.22711 16.0728Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const El = /* @__PURE__ */ ge(Sl, [["render", Tl]]), kl = ["width", "height"], Ml = ["d"], Al = /* @__PURE__ */ ae({
  __name: "SplittingArrow",
  props: {
    populationIconRef: {},
    armsContainerRef: {},
    armCount: {},
    color: {},
    populationId: {},
    isRandomized: { type: Boolean },
    showAddArm: { type: Boolean }
  },
  emits: ["update:isRandomized", "addArm"],
  setup(e, { expose: t, emit: n }) {
    const o = e, i = n, { mode: r } = Ue(), l = M(null), s = M({ width: 0, height: 0 }), d = M(0), u = M([]), m = M(0), c = M(0), a = k(() => s.value.width), f = k(() => s.value.height), v = k(
      () => ({
        marginTop: "0px",
        flexShrink: 0,
        position: "absolute",
        left: `${m.value}px`,
        top: `${c.value}px`,
        pointerEvents: "none",
        zIndex: 1
      })
    ), T = k(() => {
      if (a.value <= 0) return { x: 0, y: 0 };
      const C = 0, B = d.value, O = Math.min(150, a.value * 0.7);
      return { x: C + O, y: B };
    }), $ = k(() => {
      if (a.value <= 0) return { x: 0, y: 0 };
      const C = 0, B = d.value;
      return { x: C + Math.min(70, a.value * 0.3), y: B };
    }), E = k(() => o.armCount > 1 && s.value.width > 0), x = k(() => ({
      position: "absolute",
      left: `${$.value.x}px`,
      top: `${$.value.y}px`,
      transform: "translate(-50%, -50%)",
      width: "48px",
      height: "48px"
    })), g = k(() => ({
      position: "absolute",
      left: `${T.value.x}px`,
      top: `${T.value.y}px`,
      transform: "translate(-50%, -50%)",
      width: "48px",
      height: "48px"
    })), y = k(() => {
      if (u.value.length === 0 || a.value <= 0) return [];
      const C = 0, B = a.value, O = d.value, P = 12;
      if (o.armCount === 1 && u.value.length === 1) {
        const z = u.value[0];
        return [`M ${C} ${O} L ${B} ${z}`];
      }
      const { x: U, y: _ } = T.value;
      return u.value.map((z) => {
        const ee = z > _ ? 1 : -1, le = U - P, ie = _, te = z - P * ee, re = U;
        return `M ${C} ${O} L ${le} ${ie} Q ${U} ${_} ${U} ${_ + P * ee} L ${re} ${te} Q ${U} ${z} ${U + P} ${z} L ${B} ${z}`;
      });
    });
    function S() {
      if (!o.populationIconRef || !o.armsContainerRef || !l.value) return;
      const C = l.value.parentElement;
      if (!C) return;
      const B = o.populationIconRef.getBoundingClientRect(), O = C.getBoundingClientRect(), P = o.armsContainerRef.querySelectorAll(":scope > div"), U = [];
      if (P.forEach((se) => {
        const be = se.querySelector("button");
        if (be) {
          const ue = be.getBoundingClientRect();
          U.push({ y: ue.top + ue.height / 2, left: ue.left });
        } else {
          const ue = se.getBoundingClientRect();
          U.push({ y: ue.top + ue.height / 2, left: ue.left });
        }
      }), U.length === 0 && o.armCount > 0) {
        const se = o.armsContainerRef.getBoundingClientRect();
        U.push({ y: se.top + se.height / 2, left: se.left });
      }
      if (U.length === 0) {
        s.value = { width: 0, height: 0 };
        return;
      }
      const _ = B.top + B.height / 2, z = Math.min(...U.map((se) => se.left)), X = B.right, le = Math.max(z - X, 20), ie = [_, ...U.map((se) => se.y)], te = Math.min(...ie), re = Math.max(...ie), me = 20, Me = re - te + me * 2;
      s.value = {
        width: le,
        height: Me
      }, m.value = X - O.left, c.value = te - me - O.top, d.value = _ - (te - me), u.value = U.map((se) => se.y - (te - me));
    }
    let b = null;
    return vt(() => {
      Vt(() => {
        S();
      }), b = new ResizeObserver(() => {
        S();
      }), o.armsContainerRef && b.observe(o.armsContainerRef), window.addEventListener("resize", S);
    }), Sn(() => {
      b?.disconnect(), window.removeEventListener("resize", S);
    }), ce(
      () => [o.populationIconRef, o.armsContainerRef, o.armCount],
      () => {
        Vt(() => {
          S();
        });
      },
      { deep: !0 }
    ), t({ recalculate: S }), (C, B) => (w(), A("div", {
      ref_key: "rootRef",
      ref: l,
      class: "pointer-events-none overflow-visible",
      style: ze(v.value)
    }, [
      (w(), A("svg", {
        class: "overflow-visible block",
        width: a.value,
        height: f.value
      }, [
        (w(!0), A(de, null, pe(y.value, (O, P) => (w(), A("path", {
          key: P,
          d: O,
          fill: "none",
          stroke: "#475569",
          "stroke-width": "4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ml))), 128))
      ], 8, kl)),
      e.showAddArm ? (w(), A("button", {
        key: 0,
        class: J(["pointer-events-auto absolute flex items-center justify-center rounded-full bg-white shadow-md border-2 border-slate-600 transition-colors z-10", ["text-slate-600", "hover:bg-slate-50 cursor-pointer"]]),
        style: ze(x.value),
        onClick: B[0] || (B[0] = Se((O) => i("addArm"), ["stop"])),
        title: "Add Arm"
      }, [
        Q($l)
      ], 4)) : q("", !0),
      E.value ? (w(), A("button", {
        key: 1,
        class: J(["pointer-events-auto absolute flex items-center justify-center rounded-full bg-white shadow-md border-2 border-slate-600 transition-colors z-10", [
          e.isRandomized ? "text-red-500" : "text-slate-600",
          h(r) === "edit" ? "hover:bg-slate-50 cursor-pointer" : "cursor-default"
        ]]),
        style: ze(g.value),
        onClick: B[1] || (B[1] = Se((O) => h(r) === "edit" ? i("update:isRandomized", !e.isRandomized) : void 0, ["stop"])),
        title: "Toggle Randomization"
      }, [
        Q(El)
      ], 6)) : q("", !0)
    ], 4));
  }
}), Bl = /* @__PURE__ */ ae({
  __name: "TimepointArrow",
  props: {
    gray: { type: Boolean, default: !1 },
    color: { default: 0 }
  },
  setup(e) {
    const t = e, n = k(() => $e[t.color % $e.length]), o = k(() => t.gray ? "bg-slate-300" : n.value.line), i = k(
      () => t.gray ? "border-l-slate-300" : n.value.arrow
    );
    return (r, l) => (w(), A("div", {
      class: J(["absolute right-full translate-x-1 w-30 h-4", o.value])
    }, [
      p("div", {
        class: J(["absolute right-0 top-1/2 -translate-y-1/2 -translate-x-5 w-0 h-0 border-t-16 border-t-transparent border-b-16 border-b-transparent border-l-16", i.value])
      }, null, 2)
    ], 2));
  }
}), Rl = { class: "text-sm font-bold text-white cursor-pointer" }, Dl = {
  key: 1,
  class: "absolute top-full left-1/2 -translate-x-1/2 mt-1 flex items-center gap-1 h-8 z-20"
}, Ll = /* @__PURE__ */ ae({
  __name: "TimepointCircle",
  props: {
    hasExposure: { type: Boolean },
    showArrow: { type: Boolean },
    label: {},
    color: {},
    canDelete: { type: Boolean },
    isHovered: { type: Boolean },
    isDirectlyHovered: { type: Boolean },
    isBaseline: { type: Boolean },
    participantCount: {},
    isMerged: { type: Boolean },
    secondaryColor: {},
    secondaryIsBaseline: { type: Boolean },
    isSelected: { type: Boolean },
    isSelectable: { type: Boolean },
    isHighlighted: { type: Boolean },
    isMiddle: { type: Boolean }
  },
  emits: ["click", "clear-exposure", "edit-count", "edit-name", "mouseenter", "mouseleave"],
  setup(e) {
    const t = M(!1), n = {
      "bg-orange-400": "#fb923c",
      "bg-orange-600": "#ea580c",
      "bg-blue-400": "#60a5fa",
      "bg-blue-600": "#2563eb",
      "bg-green-400": "#4ade80",
      "bg-green-600": "#16a34a",
      "bg-purple-400": "#c084fc",
      "bg-purple-600": "#9333ea",
      "bg-pink-400": "#f472b6",
      "bg-pink-600": "#db2777",
      "bg-teal-400": "#2dd4bf",
      "bg-teal-600": "#0d9488",
      "bg-amber-400": "#fbbf24",
      "bg-amber-600": "#d97706",
      "bg-cyan-400": "#22d3ee",
      "bg-cyan-600": "#0891b2",
      "bg-slate-300": "#cbd5e1",
      "bg-slate-400": "#94a3b8",
      "bg-slate-100": "#f1f5f9"
    }, o = e, i = k(() => {
      if (!o.isMerged) return null;
      if (o.secondaryIsBaseline)
        return n["bg-slate-300"];
      if (o.secondaryColor === void 0) return null;
      const c = $e[o.secondaryColor % $e.length];
      return n[c.outer];
    }), r = k(() => {
      if (!o.isMerged) return null;
      if (o.secondaryIsBaseline)
        return n["bg-slate-400"];
      if (o.secondaryColor === void 0) return null;
      const c = $e[o.secondaryColor % $e.length];
      return n[c.inner];
    }), l = k(() => {
      if (!o.isMerged || !i.value) return u.value;
      const c = u.value.backgroundColor;
      return {
        backgroundImage: `linear-gradient(90deg, ${i.value} 0%, ${i.value} 50%, ${c} 50%, ${c} 100%)`
      };
    }), s = k(() => {
      if (!o.isMerged || !r.value) return m.value;
      const c = m.value.backgroundColor;
      return {
        backgroundImage: `linear-gradient(90deg, ${r.value} 0%, ${r.value} 50%, ${c} 50%, ${c} 100%)`
      };
    }), d = k(() => {
      const c = o.color ?? 0;
      return $e[c % $e.length];
    }), u = k(() => o.isBaseline ? { backgroundColor: n["bg-slate-300"] } : o.hasExposure ? { backgroundColor: n[d.value.outer] } : {}), m = k(() => o.isBaseline ? { backgroundColor: n["bg-slate-400"] } : o.hasExposure ? { backgroundColor: n[d.value.inner] } : { backgroundColor: n["bg-slate-100"] });
    return (c, a) => (w(), A("div", {
      class: "relative flex items-center group",
      onMouseenter: a[5] || (a[5] = (f) => e.isMiddle ? t.value = !0 : void 0),
      onMouseleave: a[6] || (a[6] = (f) => e.isMiddle ? t.value = !1 : void 0)
    }, [
      e.showArrow ? (w(), oe(Bl, {
        key: 0,
        color: e.color
      }, null, 8, ["color"])) : q("", !0),
      p("div", {
        class: J(["relative z-10 transition-[clip-path] duration-200 ease-out", e.isMiddle && !t.value ? "clip-top-half" : "clip-none"])
      }, [
        p("button", {
          class: J(["size-16 shadow-md rounded-full flex items-center justify-center z-10 cursor-pointer transition-all", [
            e.isBaseline && !e.isSelected && !e.isHighlighted ? [
              "bg-slate-300",
              e.isDirectlyHovered && e.isSelectable === void 0 ? "scale-110 ring-2 ring-slate-400 ring-offset-1" : e.isSelectable ? "hover:ring-2 hover:ring-blue-300 hover:ring-offset-1" : "",
              e.isSelectable === !1 ? "opacity-30 cursor-not-allowed" : ""
            ] : e.hasExposure ? [
              e.isSelected ? "scale-110 ring-2 ring-blue-600 ring-offset-2" : e.isHighlighted ? "scale-105 ring-2 ring-yellow-400 ring-offset-2" : e.isDirectlyHovered ? "scale-110 ring-2 ring-slate-400 ring-offset-1" : e.isHovered === !1 ? "opacity-50 hover:scale-105" : e.isSelectable ? "hover:ring-2 hover:ring-blue-300 hover:ring-offset-1" : "",
              e.isSelectable === !1 && !e.isSelected && !e.isHighlighted ? "opacity-30 cursor-not-allowed" : ""
            ] : "bg-slate-300 hover:bg-slate-400 opacity-0 group-hover:opacity-100"
          ]]),
          style: ze(l.value),
          onClick: a[0] || (a[0] = Se((f) => e.isSelectable !== !1 ? c.$emit("click", f) : void 0, ["stop"])),
          onMouseenter: a[1] || (a[1] = (f) => c.$emit("mouseenter")),
          onMouseleave: a[2] || (a[2] = (f) => c.$emit("mouseleave"))
        }, [
          p("div", {
            class: "size-12 rounded-full flex flex-col items-center justify-center",
            style: ze(s.value)
          }, [
            (w(), A("svg", {
              class: J(["transition-all", {
                "opacity-0": e.isMiddle && !t.value
              }]),
              width: "15",
              height: "12",
              viewBox: "0 0 15 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [...a[7] || (a[7] = [
              $n('<path d="M9.6 2.4C9.6 3.72548 8.52548 4.8 7.2 4.8C5.87452 4.8 4.8 3.72548 4.8 2.4C4.8 1.07452 5.87452 0 7.2 0C8.52548 0 9.6 1.07452 9.6 2.4Z" fill="white" data-v-79c0fee1></path><path d="M13.6 4C13.6 4.88366 12.8837 5.6 12 5.6C11.1163 5.6 10.4 4.88366 10.4 4C10.4 3.11634 11.1163 2.4 12 2.4C12.8837 2.4 13.6 3.11634 13.6 4Z" fill="white" data-v-79c0fee1></path><path d="M10.4 9.6C10.4 7.83269 8.96731 6.4 7.2 6.4C5.43269 6.4 4 7.83269 4 9.6V12H10.4V9.6Z" fill="white" data-v-79c0fee1></path><path d="M4 4C4 4.88366 3.28366 5.6 2.4 5.6C1.51634 5.6 0.8 4.88366 0.8 4C0.8 3.11634 1.51634 2.4 2.4 2.4C3.28366 2.4 4 3.11634 4 4Z" fill="white" data-v-79c0fee1></path><path d="M12 12V9.6C12 8.75668 11.7825 7.96416 11.4006 7.27546C11.5922 7.2262 11.793 7.2 12 7.2C13.3255 7.2 14.4 8.27452 14.4 9.6V12H12Z" fill="white" data-v-79c0fee1></path><path d="M2.99941 7.27546C2.61748 7.96416 2.4 8.75668 2.4 9.6V12H0V9.6C0 8.27452 1.07452 7.2 2.4 7.2C2.60697 7.2 2.80782 7.2262 2.99941 7.27546Z" fill="white" data-v-79c0fee1></path>', 6)
            ])], 2)),
            p("span", Rl, ne(e.participantCount ?? 0), 1)
          ], 4)
        ], 38)
      ], 2),
      e.label ? (w(), A("div", Dl, [
        p("button", {
          class: J(["text-xs font-medium whitespace-nowrap hover:text-indigo-600 transition-colors", [
            e.hasExposure ? "text-slate-600" : "text-slate-400",
            (e.isSelectable, "cursor-pointer")
          ]]),
          onClick: a[3] || (a[3] = Se(
            () => {
              h(V).user("Edit timepoint name clicked"), c.$emit("edit-name");
            },
            ["stop"]
          ))
        }, ne(e.label), 3),
        e.canDelete ? (w(), A("button", {
          key: 0,
          class: "text-red-500 hover:text-red-700 flex hover:bg-red-50 hover:scale-125 opacity-0 group-hover/intervention:opacity-100 transition-all rounded-lg p-0.5",
          title: "Delete Timepoint",
          onClick: a[4] || (a[4] = Se(
            () => {
              h(V).user("Delete timepoint clicked"), c.$emit("clear-exposure");
            },
            ["stop"]
          ))
        }, [
          Q(zt)
        ])) : q("", !0)
      ])) : q("", !0)
    ], 32));
  }
}), bn = /* @__PURE__ */ ge(Ll, [["__scopeId", "data-v-79c0fee1"]]), Nl = { class: "p-4 w-[320px] space-y-3" }, Pl = { class: "flex flex-col gap-3" }, Vl = ["value"], Ol = ["value"], Hl = {
  for: "duration-value1",
  class: "text-xs font-medium text-slate-600 mb-1 block"
}, Fl = ["min"], zl = { key: 0 }, Zl = ["min"], jl = ["value"], Ul = { class: "flex items-center justify-between pt-2 border-t border-slate-100" }, Wl = { class: "flex gap-2" }, ho = /* @__PURE__ */ ae({
  __name: "InterventionDurationMenu",
  props: {
    referenceEl: {},
    canMergeDuration: { type: Boolean },
    operator: {},
    value1: {},
    value2: {},
    unit: {},
    units: {}
  },
  emits: ["update:operator", "update:value1", "update:value2", "update:unit", "save", "cancel", "clear"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = k({
      get: () => n.operator,
      set: (d) => o("update:operator", d)
    }), r = k({
      get: () => n.value1,
      set: (d) => o("update:value1", d)
    }), l = k({
      get: () => n.value2,
      set: (d) => o("update:value2", d)
    }), s = k({
      get: () => n.unit,
      set: (d) => o("update:unit", d)
    });
    return (d, u) => e.referenceEl ? (w(), oe(je, {
      key: 0,
      "reference-el": e.referenceEl,
      onClose: u[7] || (u[7] = (m) => o("cancel"))
    }, {
      default: Pe(() => [
        p("div", Nl, [
          u[11] || (u[11] = p("h3", { class: "text-sm font-semibold text-slate-800" }, "Set Duration", -1)),
          p("div", Pl, [
            p("div", null, [
              u[8] || (u[8] = p("label", {
                for: "duration-operator",
                class: "text-xs font-medium text-slate-600 mb-1 block"
              }, "Operator", -1)),
              ke(p("select", {
                id: "duration-operator",
                "onUpdate:modelValue": u[0] || (u[0] = (m) => i.value = m),
                class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm focus:bg-white focus:ring-2 focus:ring-slate-200"
              }, [
                p("option", {
                  value: h(fe).EXACT
                }, "Is exactly", 8, Vl),
                p("option", {
                  value: h(fe).BETWEEN
                }, "Is between", 8, Ol)
              ], 512), [
                [Dn, i.value]
              ])
            ]),
            p("div", {
              class: J(["grid gap-2", i.value === h(fe).BETWEEN ? "grid-cols-2" : "grid-cols-1"])
            }, [
              p("div", null, [
                p("label", Hl, ne(i.value === h(fe).BETWEEN ? "From" : "Value"), 1),
                ke(p("input", {
                  id: "duration-value1",
                  "onUpdate:modelValue": u[1] || (u[1] = (m) => r.value = m),
                  type: "number",
                  min: e.canMergeDuration ? 0 : 0.1,
                  step: "0.1",
                  class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200"
                }, null, 8, Fl), [
                  [
                    Ze,
                    r.value,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ]),
              i.value === h(fe).BETWEEN ? (w(), A("div", zl, [
                u[9] || (u[9] = p("label", {
                  for: "duration-value2",
                  class: "text-xs font-medium text-slate-600 mb-1 block"
                }, "To", -1)),
                ke(p("input", {
                  id: "duration-value2",
                  "onUpdate:modelValue": u[2] || (u[2] = (m) => l.value = m),
                  type: "number",
                  min: e.canMergeDuration ? 0 : 0.1,
                  step: "0.1",
                  class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200"
                }, null, 8, Zl), [
                  [
                    Ze,
                    l.value,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])) : q("", !0)
            ], 2),
            p("div", null, [
              u[10] || (u[10] = p("label", {
                for: "duration-unit",
                class: "text-xs font-medium text-slate-600 mb-1 block"
              }, "Unit", -1)),
              ke(p("select", {
                id: "duration-unit",
                "onUpdate:modelValue": u[3] || (u[3] = (m) => s.value = m),
                class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm focus:bg-white focus:ring-2 focus:ring-slate-200"
              }, [
                (w(!0), A(de, null, pe(e.units, (m) => (w(), A("option", {
                  key: m,
                  value: m
                }, ne(m), 9, jl))), 128))
              ], 512), [
                [Dn, s.value]
              ])
            ])
          ]),
          p("div", Ul, [
            p("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg text-red-600 hover:bg-red-50 transition-all",
              onClick: u[4] || (u[4] = (m) => o("clear"))
            }, " Clear "),
            p("div", Wl, [
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-all",
                onClick: u[5] || (u[5] = (m) => o("cancel"))
              }, " Cancel "),
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
                onClick: u[6] || (u[6] = (m) => o("save"))
              }, " Save ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : q("", !0);
  }
}), ql = { class: "p-4 w-55 space-y-3" }, Xl = { class: "flex flex-col gap-2" }, Gl = { class: "flex items-center justify-between pt-2 border-t border-slate-100" }, Yl = { class: "flex gap-2" }, yn = /* @__PURE__ */ ae({
  __name: "InterventionParticipantCountMenu",
  props: {
    referenceEl: {},
    value: {}
  },
  emits: ["update:value", "save", "cancel", "clear"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = k({
      get: () => n.value,
      set: (r) => o("update:value", r)
    });
    return (r, l) => e.referenceEl ? (w(), oe(je, {
      key: 0,
      "reference-el": e.referenceEl,
      onClose: l[6] || (l[6] = (s) => o("cancel"))
    }, {
      default: Pe(() => [
        p("div", ql, [
          l[8] || (l[8] = p("h3", { class: "text-sm font-semibold text-slate-800" }, "Participants", -1)),
          p("div", Xl, [
            l[7] || (l[7] = p("label", {
              for: "participant-count-input",
              class: "text-xs font-medium text-slate-600"
            }, "Number of participants", -1)),
            ke(p("input", {
              id: "participant-count-input",
              "onUpdate:modelValue": l[0] || (l[0] = (s) => i.value = s),
              type: "number",
              min: "0",
              class: "h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
              placeholder: "Enter count",
              onKeydown: [
                l[1] || (l[1] = nt((s) => o("save"), ["enter"])),
                l[2] || (l[2] = nt((s) => o("cancel"), ["esc"]))
              ]
            }, null, 544), [
              [
                Ze,
                i.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          p("div", Gl, [
            p("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg text-red-600 hover:bg-red-50 transition-all",
              onClick: l[3] || (l[3] = (s) => o("clear"))
            }, " Clear "),
            p("div", Yl, [
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-all",
                onClick: l[4] || (l[4] = (s) => o("cancel"))
              }, " Cancel "),
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
                onClick: l[5] || (l[5] = (s) => o("save"))
              }, " Save ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : q("", !0);
  }
}), _l = { class: "p-4 w-100 space-y-4" }, Kl = {
  key: 0,
  class: "space-y-1 overflow-y-auto mb-2"
}, Jl = ["onClick"], Ql = { class: "text-sm text-slate-700" }, er = { class: "space-y-2" }, tr = { class: "flex-1 h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm flex items-center" }, nr = ["onClick"], or = ["onKeydown"], ir = { class: "p-2 w-90 max-h-40 overflow-y-auto" }, lr = ["disabled", "onClick"], rr = { class: "flex items-center justify-between pt-2 border-t border-slate-100" }, sr = { class: "flex gap-2" }, ar = /* @__PURE__ */ ae({
  __name: "InterventionSettingsMenu",
  props: {
    referenceEl: {},
    intervention: {}
  },
  emits: ["close", "delete"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      updateExposure: i,
      updateIntervention: r,
      globalCharacteristics: l,
      addGlobalCharacteristic: s,
      getExposureById: d,
      exposures: u,
      getExposureColorIndex: m
    } = Ue(), c = M(""), a = M(!1), f = M(null), v = M([]);
    ce(
      () => n.intervention.exposureIds,
      (b) => {
        v.value = [...b];
      },
      { immediate: !0 }
    );
    const T = k(() => {
      const b = /* @__PURE__ */ new Set();
      return v.value.forEach((C) => {
        const B = d(C);
        B && B.characteristics.forEach((O) => b.add(O));
      }), Array.from(b);
    }), $ = k(() => {
      const b = c.value.toLowerCase();
      return l.value.filter(
        (C) => C.toLowerCase().includes(b) && !T.value.includes(C)
      );
    });
    function E(b) {
      const C = v.value.indexOf(b);
      C > -1 ? v.value.splice(C, 1) : v.value.push(b);
    }
    function x() {
      c.value.trim() && (v.value.forEach((b) => {
        const C = d(b);
        C && !C.characteristics.includes(c.value) && (V.user("Added characteristic to exposure", {
          exposureId: C.id,
          characteristic: c.value
        }), i(C.id, {
          characteristics: [...C.characteristics, c.value.trim()]
        }));
      }), s(c.value.trim()), c.value = "");
    }
    function g(b) {
      v.value.forEach((C) => {
        const B = d(C);
        B && !B.characteristics.includes(b) && (V.user("Selected characteristic for exposure", {
          exposureId: B.id,
          characteristic: b
        }), i(B.id, {
          characteristics: [...B.characteristics, b]
        }));
      }), c.value = "";
    }
    function y(b) {
      const C = T.value[b];
      C && v.value.forEach((B) => {
        const O = d(B);
        if (O && O.characteristics.includes(C)) {
          V.user("Removed characteristic from exposure", {
            exposureId: O.id,
            characteristicParam: C
          });
          const P = O.characteristics.filter((U) => U !== C);
          i(O.id, { characteristics: P });
        }
      });
    }
    function S() {
      JSON.stringify(v.value) !== JSON.stringify(n.intervention.exposureIds) && (V.user("Saving exposure changes", {
        interventionId: n.intervention.id,
        oldExposureIds: n.intervention.exposureIds,
        newExposureIds: v.value
      }), r(n.intervention.id, {
        exposureIds: [...v.value]
      })), o("close");
    }
    return (b, C) => e.referenceEl ? (w(), oe(je, {
      key: 0,
      "reference-el": e.referenceEl,
      onClose: C[5] || (C[5] = (B) => o("close"))
    }, {
      default: Pe(() => [
        p("div", _l, [
          C[8] || (C[8] = p("h3", { class: "text-sm font-semibold text-slate-800" }, "Intervention Settings", -1)),
          p("div", null, [
            C[6] || (C[6] = p("div", { class: "block text-sm font-medium text-slate-700 mb-2" }, "Exposures", -1)),
            h(u).length > 0 ? (w(), A("div", Kl, [
              (w(!0), A(de, null, pe(h(u), (B) => (w(), A("button", {
                key: B.id,
                class: J([
                  "w-full text-left px-3 py-2 rounded-lg transition-colors flex items-center gap-2",
                  v.value.includes(B.id) ? "bg-blue-100 border-2 border-blue-500" : "hover:bg-slate-100 border-2 border-transparent"
                ]),
                onClick: (O) => E(B.id)
              }, [
                p("div", {
                  class: J(["w-3 h-3 rounded-full", h($e)[h(m)(B.id)]?.inner])
                }, null, 2),
                p("span", Ql, ne(B.name), 1)
              ], 10, Jl))), 128))
            ])) : q("", !0)
          ]),
          p("div", null, [
            C[7] || (C[7] = p("label", {
              for: "characteristic-input",
              class: "block text-sm font-medium text-slate-700 mb-2"
            }, "Exposure Characteristics", -1)),
            p("div", er, [
              (w(!0), A(de, null, pe(T.value, (B, O) => (w(), A("div", {
                key: "char-" + O,
                class: "flex items-center gap-2"
              }, [
                p("span", tr, ne(B), 1),
                p("button", {
                  class: "text-red-400 hover:text-red-600 transition-colors",
                  onClick: (P) => y(O)
                }, [
                  Q(zt)
                ], 8, nr)
              ]))), 128)),
              p("div", null, [
                ke(p("input", {
                  id: "characteristic-input",
                  ref_key: "characteristicInputRef",
                  ref: f,
                  "onUpdate:modelValue": C[0] || (C[0] = (B) => c.value = B),
                  type: "text",
                  class: "h-9 w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
                  placeholder: "Add or search characteristics...",
                  onFocus: C[1] || (C[1] = (B) => a.value = !0),
                  onKeydown: nt(Se(x, ["prevent"]), ["enter"])
                }, null, 40, or), [
                  [Ze, c.value]
                ]),
                a.value && ($.value.length > 0 || c.value) ? (w(), oe(je, {
                  key: 0,
                  "reference-el": f.value,
                  onClose: C[2] || (C[2] = (B) => a.value = !1)
                }, {
                  default: Pe(() => [
                    p("div", ir, [
                      c.value && !h(l).includes(c.value) ? (w(), A("button", {
                        key: 0,
                        type: "button",
                        class: "w-full px-3 py-2 text-left text-sm hover:bg-blue-50 rounded flex items-center gap-2 text-blue-600",
                        onClick: x
                      }, [
                        Q(wt),
                        Qn(' Create "' + ne(c.value) + '" ', 1)
                      ])) : q("", !0),
                      (w(!0), A(de, null, pe($.value, (B) => (w(), A("button", {
                        key: B,
                        type: "button",
                        class: J(["w-full px-3 py-2 text-left text-sm hover:bg-slate-50 rounded", {
                          "opacity-50": T.value.includes(B)
                        }]),
                        disabled: T.value.includes(B),
                        onClick: (O) => g(B)
                      }, ne(B), 11, lr))), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["reference-el"])) : q("", !0)
              ])
            ])
          ]),
          p("div", rr, [
            p("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg text-red-600 hover:bg-red-50 transition-all",
              onClick: C[3] || (C[3] = (B) => o("delete"))
            }, " Delete Intervention "),
            p("div", sr, [
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg text-slate-600 hover:bg-slate-100 transition-all",
                onClick: C[4] || (C[4] = (B) => o("close"))
              }, " Cancel "),
              p("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
                onClick: S
              }, " Save ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : q("", !0);
  }
}), ur = { class: "p-4 w-70 space-y-3" }, cr = { class: "flex flex-col gap-2" }, dr = {
  key: 0,
  class: "flex items-center gap-2"
}, vr = { class: "flex items-center justify-end gap-2 pt-2 border-t border-slate-100" }, wn = /* @__PURE__ */ ae({
  __name: "InterventionTimepointEditMenu",
  props: {
    referenceEl: {},
    name: {},
    renameAll: { type: Boolean },
    isBaseline: { type: Boolean }
  },
  emits: ["update:name", "update:renameAll", "save", "cancel"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = k({
      get: () => n.name,
      set: (l) => o("update:name", l)
    }), r = k({
      get: () => n.renameAll,
      set: (l) => o("update:renameAll", l)
    });
    return (l, s) => e.referenceEl ? (w(), oe(je, {
      key: 0,
      "reference-el": e.referenceEl,
      onClose: s[6] || (s[6] = (d) => o("cancel"))
    }, {
      default: Pe(() => [
        p("div", ur, [
          s[9] || (s[9] = p("h3", { class: "text-sm font-semibold text-slate-800" }, "Edit Timepoint", -1)),
          p("div", cr, [
            s[7] || (s[7] = p("label", {
              for: "timepoint-name-input",
              class: "text-xs font-medium text-slate-600"
            }, "Name", -1)),
            ke(p("input", {
              id: "timepoint-name-input",
              "onUpdate:modelValue": s[0] || (s[0] = (d) => i.value = d),
              type: "text",
              class: "h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
              placeholder: "Timepoint name",
              onKeydown: [
                s[1] || (s[1] = nt((d) => o("save"), ["enter"])),
                s[2] || (s[2] = nt((d) => o("cancel"), ["esc"]))
              ]
            }, null, 544), [
              [Ze, i.value]
            ])
          ]),
          e.isBaseline ? q("", !0) : (w(), A("div", dr, [
            ke(p("input", {
              id: "rename-all-checkbox",
              "onUpdate:modelValue": s[3] || (s[3] = (d) => r.value = d),
              type: "checkbox",
              class: "w-4 h-4 text-indigo-600 border-slate-300 rounded focus:ring-2 focus:ring-indigo-500"
            }, null, 512), [
              [Io, r.value]
            ]),
            s[8] || (s[8] = p("label", {
              for: "rename-all-checkbox",
              class: "text-xs text-slate-600 cursor-pointer"
            }, " Rename all timepoints with same name ", -1))
          ])),
          p("div", vr, [
            p("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-all",
              onClick: s[4] || (s[4] = (d) => o("cancel"))
            }, " Cancel "),
            p("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
              onClick: s[5] || (s[5] = (d) => o("save"))
            }, " Save ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : q("", !0);
  }
});
function fr() {
  const e = M(/* @__PURE__ */ new Map()), t = M(/* @__PURE__ */ new Map()), n = M(null), o = M(null), i = M(null), r = M(null), l = M(null), s = M(null);
  function d(a, f) {
    f && typeof f == "object" ? e.value.set(a, f) : e.value.delete(a);
  }
  function u(a, f) {
    f && f instanceof HTMLElement ? t.value.set(a, f) : t.value.delete(a);
  }
  function m(a) {
    a && a instanceof HTMLElement ? n.value = a : n.value = null;
  }
  function c(a) {
    a && a instanceof HTMLElement ? l.value = a : l.value = null;
  }
  return {
    timepointCircleRefs: e,
    lineSegmentRefs: t,
    baselineLineRef: n,
    baselineMergedScheduleRef: o,
    interventionNameRef: i,
    addTimepointFrontButtonRef: r,
    interventionGapLineRef: l,
    interventionGapMergedScheduleRef: s,
    setTimepointCircleRef: d,
    setLineSegmentRef: u,
    setBaselineLineRef: m,
    setInterventionGapLineRef: c
  };
}
function pr(e) {
  const t = M(null), n = M(null), o = M(null), i = M(""), r = M(!1), l = M(null), s = M(void 0), d = M(!1);
  function u(S) {
    return e.intervention.value.timepoints.find((b) => b.id === S);
  }
  function m(S) {
    t.value = S;
    const b = u(S);
    b && (n.value = b.name, e.setHoveredTimepoint(b.name));
  }
  function c() {
    t.value = null, n.value = null, e.setHoveredTimepoint(null);
  }
  function a(S) {
    if (!e.hoveredTimepointId.value) return !0;
    const b = u(S);
    return b ? b.name === e.hoveredTimepointId.value : !1;
  }
  function f(S) {
    return t.value === S;
  }
  function v(S) {
    const b = u(S);
    b && (V.user("Started editing timepoint name", { timepointId: S, name: b.name }), o.value = S, i.value = b.name, r.value = !1);
  }
  function T() {
    o.value && i.value.trim() && (V.user("Saved timepoint name", {
      timepointId: o.value,
      newName: i.value,
      applyToAll: r.value
    }), e.updateTimepointName(
      e.intervention.value.id,
      o.value,
      i.value.trim(),
      r.value
    ), o.value = null, i.value = "", r.value = !1);
  }
  function $() {
    o.value = null, i.value = "", r.value = !1;
  }
  function E(S) {
    V.user("Started editing participant count", { timepointId: S }), l.value = S;
    const b = u(S);
    s.value = b?.participantCount;
  }
  function x() {
    if (!l.value) return;
    V.user("Saved participant count", {
      timepointId: l.value,
      count: s.value
    });
    const S = e.intervention.value.timepoints.map(
      (b) => b.id === l.value ? { ...b, participantCount: s.value } : b
    );
    e.updateIntervention(e.intervention.value.id, { timepoints: S }), l.value = null, s.value = void 0;
  }
  function g() {
    if (!l.value) return;
    V.user("Cleared participant count for timepoint", {
      timepointId: l.value,
      interventionId: e.intervention.value.id
    });
    const S = e.intervention.value.timepoints.map(
      (b) => b.id === l.value ? { ...b, participantCount: void 0 } : b
    );
    e.updateIntervention(e.intervention.value.id, { timepoints: S }), l.value = null, s.value = void 0;
  }
  function y() {
    l.value = null, s.value = void 0;
  }
  return {
    directlyHoveredTimepointId: t,
    editingTimepointId: o,
    editingTimepointName: i,
    renameAllWithSameName: r,
    editingParticipantCountForTimepoint: l,
    editingParticipantCountValue: s,
    showInterventionMenu: d,
    handleTimepointHover: m,
    handleTimepointLeave: c,
    isTimepointHovered: a,
    isTimepointDirectlyHovered: f,
    handleTimepointClick: v,
    handleSaveTimepointName: T,
    handleCancelEdit: $,
    handleEditParticipantCount: E,
    handleSaveParticipantCount: x,
    handleClearParticipantCount: g,
    handleCancelParticipantCount: y
  };
}
const xo = ["minutes", "hours", "days", "weeks", "months", "years"];
function Ee(e) {
  return e ? e.operator === fe.EXACT ? e.value1 === 0 : e.operator === fe.BETWEEN ? e.value1 === 0 && e.value2 === 0 : !1 : !1;
}
function Pt(e) {
  return e.operator === fe.EXACT ? `${e.value1} ${e.unit}` : `${e.value1}-${e.value2} ${e.unit}`;
}
function mr(e, t) {
  return e.timepoints.find((n) => n.id === t);
}
function gr(e) {
  return e.timepoints.find((t) => t.isStart);
}
function Ge(e) {
  return e.timepoints.find((t) => t.isEnd);
}
function Lt(e) {
  return e.timepoints.find((t) => t.isBaseline);
}
function hr(e) {
  const t = M(null), n = M(fe.EXACT), o = M(0), i = M(0), r = M("days");
  function l(g) {
    if (g) {
      n.value = g.operator, o.value = g.value1 || 0, i.value = g.value2 || 0, r.value = g.unit || "days";
      return;
    }
    n.value = fe.EXACT, o.value = 0, i.value = 0, r.value = "days";
  }
  const s = k(() => {
    const g = Lt(e.intervention.value);
    return Ee(g?.duration);
  }), d = k(() => {
    if (!e.nextIntervention.value) return !1;
    const g = Ge(e.intervention.value);
    return Ee(g?.duration);
  }), u = k(() => {
    if (!t.value) return null;
    if (t.value === "baseline")
      return s.value ? e.baselineMergedScheduleRef.value : e.baselineLineRef.value;
    if (t.value === "interventionStart") {
      const y = d.value, S = e.previousIntervention.value && (() => {
        const b = Ge(e.previousIntervention.value);
        return Ee(b?.duration);
      })();
      return y || S ? e.interventionGapMergedScheduleRef.value : e.interventionGapLineRef.value;
    }
    const g = e.sortedTimepoints.value.findIndex(
      (y) => y.id === t.value
    );
    if (g >= 0) {
      const y = e.sortedTimepoints.value[g]?.id;
      return y && e.lineSegmentRefs.value.get(y) || null;
    }
    return null;
  }), m = k(() => t.value ? t.value === "baseline" || t.value === "interventionStart" : !1);
  function c(g) {
    const y = e.sortedTimepoints.value.find((S) => S.id === g);
    y && (t.value = y.id, l(y.duration));
  }
  function a() {
    t.value = "baseline";
    const g = Lt(e.intervention.value);
    l(g?.duration);
  }
  function f() {
    if (e.nextIntervention.value) {
      t.value = "interventionStart";
      const g = Ge(e.intervention.value);
      l(g?.duration);
    } else if (e.previousIntervention.value) {
      t.value = "interventionStart";
      const g = Ge(e.previousIntervention.value);
      l(g?.duration);
    }
  }
  function v(g, y, S) {
    const b = g.timepoints.map(
      (C) => C.id === y ? { ...C, duration: S } : C
    );
    e.updateIntervention(g.id, {
      timepoints: b
    });
  }
  function T(g) {
    const y = Lt(e.intervention.value);
    if (!y) return;
    if (Ee(g) && !Ee(y.duration)) {
      const b = gr(e.intervention.value);
      if (b?.participantCount) {
        const C = e.intervention.value.timepoints.map(
          (B) => B.id === y.id ? {
            ...B,
            duration: g,
            participantCount: b.participantCount
          } : B
        );
        e.updateIntervention(e.intervention.value.id, {
          timepoints: C
        }), V.user("Merged baseline with start, copied participant count", {
          participantCount: b.participantCount
        });
        return;
      }
    }
    v(e.intervention.value, y.id, g);
  }
  function $() {
    if (!t.value || !m.value && (n.value === fe.EXACT && o.value === 0 || n.value === fe.BETWEEN && o.value === 0 && i.value === 0))
      return;
    const g = {
      operator: n.value,
      value1: o.value,
      value2: n.value === fe.BETWEEN ? i.value : void 0,
      unit: r.value
    };
    if (t.value === "interventionStart") {
      if (e.nextIntervention.value) {
        const y = Ge(e.intervention.value);
        y && v(e.intervention.value, y.id, g);
      } else if (e.previousIntervention.value) {
        const y = Ge(e.previousIntervention.value);
        y && v(e.previousIntervention.value, y.id, g);
      }
    } else t.value === "baseline" ? T(g) : v(e.intervention.value, t.value, g);
    V.user("Saved duration", {
      segment: t.value,
      duration: Pt(g)
    }), t.value = null;
  }
  function E() {
    if (t.value) {
      if (V.user("Cleared duration", {
        segment: t.value
      }), t.value === "interventionStart") {
        if (e.nextIntervention.value) {
          const g = Ge(e.intervention.value);
          g && v(e.intervention.value, g.id, void 0);
        } else if (e.previousIntervention.value) {
          const g = Ge(e.previousIntervention.value);
          g && v(e.previousIntervention.value, g.id, void 0);
        }
      } else if (t.value === "baseline") {
        const g = Lt(e.intervention.value);
        g && v(e.intervention.value, g.id, void 0);
      } else {
        const g = mr(
          e.intervention.value,
          t.value
        );
        g && v(e.intervention.value, g.id, void 0);
      }
      t.value = null;
    }
  }
  function x() {
    t.value = null;
  }
  return {
    editingDurationForSegment: t,
    durationOperator: n,
    durationValue1: o,
    durationValue2: i,
    durationUnit: r,
    durationEditReferenceEl: u,
    canMergeDuration: m,
    isBaselineMerged: s,
    isInterventionGapMerged: d,
    handleLineClick: c,
    handleBaselineLineClick: a,
    handleInterventionGapClick: f,
    handleSaveDuration: $,
    handleClearDuration: E,
    handleCancelDuration: x
  };
}
function cn(e) {
  return e.timepoints.find((t) => t.isEnd);
}
function xr(e) {
  return e.timepoints.find((t) => t.isBaseline);
}
function br(e) {
  const t = k(() => {
    if (!e.previousIntervention.value) return !1;
    const r = cn(e.previousIntervention.value);
    return Ee(r?.duration);
  }), n = k(() => {
    if (!e.nextIntervention.value) return !1;
    const r = cn(e.intervention.value);
    return Ee(r?.duration);
  });
  function o(r) {
    if (!e.sortedTimepoints.value[r]) return !1;
    if (r === 0) {
      const d = xr(e.intervention.value);
      if (d)
        return Ee(d?.duration);
      if (e.previousIntervention.value) {
        const u = cn(e.previousIntervention.value);
        return Ee(u?.duration);
      }
      return !1;
    }
    const s = e.sortedTimepoints.value[r - 1];
    return Ee(s?.duration);
  }
  function i(r) {
    if (o(r))
      return r === 0 && e.previousIntervention.value ? e.getExposureColorIndex(e.previousIntervention.value.exposureIds[0] ?? "") : e.colorIndex.value;
  }
  return {
    isMergedWithPreviousIntervention: t,
    isMergedWithNextIntervention: n,
    isZeroDistance: o,
    getMergedSecondaryColor: i
  };
}
const yr = {}, wr = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Cr(e, t) {
  return w(), A("svg", wr, [...t[0] || (t[0] = [
    p("path", {
      d: "M7 1.40039C10.0928 1.40039 12.5996 3.90721 12.5996 7C12.5996 10.0928 10.0928 12.5996 7 12.5996C3.90721 12.5996 1.40039 10.0928 1.40039 7C1.40039 3.90721 3.90721 1.40039 7 1.40039ZM7 3.2002C6.44772 3.2002 6 3.64791 6 4.2002V7C6.00005 7.2651 6.10554 7.51955 6.29297 7.70703L8.27246 9.6875C8.66283 10.0778 9.29599 10.0775 9.68652 9.6875C10.077 9.29701 10.077 8.66397 9.68652 8.27344L8 6.58594V4.2002C8 3.64791 7.55228 3.2002 7 3.2002Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Cn = /* @__PURE__ */ ge(yr, [["render", Cr]]), $r = {}, Sr = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function Ir(e, t) {
  return w(), A("svg", Sr, [...t[0] || (t[0] = [
    p("path", { d: "m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z" }, null, -1)
  ])]);
}
const Xn = /* @__PURE__ */ ge($r, [["render", Ir]]), Tr = { class: "flex items-center relative flex-1 h-full" }, Er = {
  key: 0,
  class: "w-24 shrink-0"
}, kr = { class: "relative flex items-center flex-1 h-full" }, Mr = ["onClick"], Ar = {
  key: 2,
  class: "relative flex items-center group/add-tp"
}, Br = ["onClick"], Rr = {
  key: 0,
  class: "text-white whitespace-nowrap text-sm flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20"
}, Dr = {
  key: 1,
  class: "size-6 text-white rounded-full flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20"
}, Lr = {
  key: 0,
  class: "absolute left-0 top-1/2 -translate-y-1/2 flex items-center group/baseline-line"
}, Nr = { class: "border-2 bg-white border-gray-800 rounded-full flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20" }, Pr = {
  key: 0,
  class: "text-xs font-medium text-slate-500 px-2 whitespace-nowrap"
}, Vr = {
  key: 1,
  class: "flex items-center justify-center p-0.5 text-gray-600"
}, Or = {
  key: 1,
  class: "relative flex items-center group/inter-gap shrink-0"
}, Hr = { class: "border-2 bg-white border-gray-800 rounded-full flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20" }, Fr = {
  key: 0,
  class: "text-xs font-medium text-slate-500 px-2 whitespace-nowrap"
}, zr = {
  key: 1,
  class: "flex items-center justify-center p-0.5 text-gray-600"
}, Zr = /* @__PURE__ */ ae({
  __name: "InterventionTimeline",
  props: {
    intervention: {},
    colorIndex: {},
    isFirstIntervention: { type: Boolean },
    isLastIntervention: { type: Boolean },
    previousIntervention: {},
    nextIntervention: {}
  },
  emits: ["select", "duplicate-from", "remove"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      getExposureById: i,
      addTimepointToIntervention: r,
      removeTimepointFromIntervention: l,
      hoveredTimepointId: s,
      setHoveredTimepoint: d,
      updateTimepointName: u,
      updateIntervention: m,
      getExposureColorIndex: c,
      mode: a,
      selectedTimepointNames: f,
      toggleTimepointSelection: v,
      selectedInterventionIds: T,
      toggleInterventionSelection: $,
      commonTimepointNamesInSelectedInterventions: E
    } = Ue(), x = k(() => {
      const Y = K.value.map((j) => j.name), Z = n.intervention.timepoints.find((j) => j.isBaseline);
      return Z && Y.unshift(Z.name), Y;
    }), g = k(() => f.value.length === 0 ? !0 : f.value.every(
      (Y) => x.value.includes(Y)
    )), y = k(() => {
      if (a.value === "select")
        return !0;
    }), {
      editingTimepointId: S,
      editingTimepointName: b,
      editingParticipantCountForTimepoint: C,
      editingParticipantCountValue: B,
      showInterventionMenu: O,
      renameAllWithSameName: P,
      handleTimepointHover: U,
      handleTimepointLeave: _,
      isTimepointHovered: z,
      isTimepointDirectlyHovered: X,
      handleTimepointClick: ee,
      handleSaveTimepointName: le,
      handleCancelEdit: ie,
      handleEditParticipantCount: te,
      handleSaveParticipantCount: re,
      handleClearParticipantCount: me,
      handleCancelParticipantCount: Me
    } = pr({
      intervention: Xe(n, "intervention"),
      hoveredTimepointId: s,
      setHoveredTimepoint: d,
      updateTimepointName: u,
      updateIntervention: m
    }), {
      timepointCircleRefs: se,
      lineSegmentRefs: be,
      baselineLineRef: ue,
      baselineMergedScheduleRef: He,
      interventionNameRef: Ae,
      interventionGapLineRef: I,
      interventionGapMergedScheduleRef: L,
      setTimepointCircleRef: D,
      setLineSegmentRef: N,
      setBaselineLineRef: G,
      setInterventionGapLineRef: W
    } = fr(), K = k(() => [...n.intervention.timepoints].filter((Y) => !Y.isBaseline).sort((Y, Z) => Y.order.localeCompare(Z.order))), {
      editingDurationForSegment: Be,
      durationOperator: he,
      durationValue1: We,
      durationValue2: ye,
      durationUnit: we,
      durationEditReferenceEl: ft,
      canMergeDuration: St,
      isBaselineMerged: Ke,
      isInterventionGapMerged: qt,
      handleLineClick: Xt,
      handleBaselineLineClick: Gt,
      handleInterventionGapClick: pt,
      handleSaveDuration: Yt,
      handleClearDuration: _t,
      handleCancelDuration: Kt
    } = hr({
      intervention: Xe(n, "intervention"),
      previousIntervention: Xe(n, "previousIntervention"),
      nextIntervention: Xe(n, "nextIntervention"),
      sortedTimepoints: K,
      baselineLineRef: ue,
      baselineMergedScheduleRef: He,
      interventionGapLineRef: I,
      interventionGapMergedScheduleRef: L,
      lineSegmentRefs: be,
      updateIntervention: m
    }), { isMergedWithPreviousIntervention: mt, isMergedWithNextIntervention: It, getMergedSecondaryColor: Jt } = br({
      intervention: Xe(n, "intervention"),
      previousIntervention: Xe(n, "previousIntervention"),
      nextIntervention: Xe(n, "nextIntervention"),
      sortedTimepoints: K,
      colorIndex: Xe(n, "colorIndex"),
      getExposureColorIndex: c
    }), rt = k(() => $e[n.colorIndex % $e.length]), Qt = k(() => rt.value.line), Tt = k(() => n.intervention.exposureIds.map((Y) => tn(Y)).join(" + ")), en = k(() => K.value[0]?.isStart ? n.isFirstIntervention && Ke.value : !1);
    function Et(Y) {
      return Y > 0 && Y < K.value.length - 1;
    }
    function kt() {
      return n.intervention.timepoints.find((Y) => Y.isBaseline);
    }
    function Mt() {
      return n.intervention.timepoints.find((Y) => Y.isEnd);
    }
    function tn(Y) {
      return i(Y)?.name ?? "Unknown";
    }
    function nn(Y) {
      const Z = K.value[Y];
      return Z ? Z.name : "";
    }
    function on(Y) {
      const Z = K.value[Y];
      return !Z || Z.isStart ? !1 : Z.isEnd ? K.value.length === 2 : K.value[Y + 1]?.isEnd === !0;
    }
    function At(Y) {
      V.user("Adding timepoint to intervention", {
        interventionId: n.intervention.id,
        afterTimepointId: Y
      }), r(n.intervention.id, Y);
    }
    function ln(Y) {
      V.user("Deleting timepoint from intervention", {
        interventionId: n.intervention.id,
        timepointId: Y
      }), l(n.intervention.id, Y);
    }
    function rn() {
      V.user("Deleting intervention", {
        interventionId: n.intervention.id
      }), O.value = !1, o("remove");
    }
    function gt(Y) {
      if (a.value !== "select" || !T.value.includes(n.intervention.id)) return !1;
      const Z = K.value.find((j) => j.id === Y);
      return Z ? f.value.includes(Z.name) : !1;
    }
    function H(Y) {
      if (a.value !== "select" || f.value.length === 0 || T.value.length === 2 && f.value.length === 2)
        return !1;
      const Z = K.value.find((ve) => ve.id === Y);
      return !Z || gt(Y) || !g.value ? !1 : T.value.includes(n.intervention.id) ? E.value.includes(Z.name) : T.value.length === 2 ? !1 : f.value.includes(Z.name) ? !0 : f.value.length === 1 ? E.value.includes(Z.name) : !1;
    }
    function R(Y) {
      if (a.value === "select") {
        const Z = K.value.find((yo) => yo.id === Y);
        if (!Z) return;
        const j = gt(Y), ve = H(Y);
        if (T.value.length === 0) {
          v(n.intervention.id, Z.name);
          return;
        }
        T.value.includes(
          n.intervention.id
        ) ? (j || ve) && v(n.intervention.id, Z.name) : ve && v(n.intervention.id, Z.name);
      } else
        te(Y);
    }
    const F = k(
      () => T.value.includes(n.intervention.id)
    ), qe = k(() => a.value !== "select" ? !1 : F.value ? !0 : g.value ? T.value.length < 2 : !1), ht = k(() => a.value !== "select" || F.value || T.value.length === 0 || T.value.length >= 2 || f.value.length === 0 ? !1 : g.value);
    function bo() {
      qe.value && $(n.intervention.id);
    }
    return (Y, Z) => (w(), A("div", {
      class: J(["flex items-center relative group/intervention transition-all h-16", [
        h(a) === "select" && F.value ? "bg-blue-100 ring-2 ring-blue-600 ring-offset-2 rounded-lg  -m-2 cursor-pointer" : h(a) === "select" && ht.value ? "bg-yellow-50 ring-2 ring-yellow-400 ring-offset-2 rounded-lg  -m-2 cursor-pointer hover:bg-yellow-100" : h(a) === "select" && qe.value ? "cursor-pointer hover:bg-blue-50 rounded-lg  -m-2" : ""
      ]]),
      onClick: Z[15] || (Z[15] = (j) => h(a) === "select" && (qe.value || F.value) ? bo() : void 0)
    }, [
      p("div", Tr, [
        e.isFirstIntervention && !h(Ke) ? (w(), A("div", Er)) : q("", !0),
        p("div", kr, [
          K.value.length > 1 ? (w(), A("div", {
            key: 0,
            ref_key: "interventionNameRef",
            ref: Ae,
            class: J(["absolute top-0 left-6 right-6 h-6 flex items-center justify-center overflow-hidden", [
              rt.value.interventionBg,
              h(a) === "edit" ? "cursor-pointer" : "cursor-default",
              {
                "-left-6!": en.value,
                "-right-6!": h(It)
              }
            ]]),
            onClick: Z[0] || (Z[0] = Se((j) => h(a) === "edit" ? O.value = !0 : void 0, ["stop"]))
          }, [
            p("span", {
              class: J(["text-xs font-medium truncate px-2", rt.value.interventionName])
            }, ne(Tt.value), 3)
          ], 2)) : q("", !0),
          (w(!0), A(de, null, pe(K.value, (j, ve) => (w(), A(de, {
            key: j.id
          }, [
            !(j.isEnd && h(It)) && !(e.isFirstIntervention && ve === 0 && j.isStart && h(Ke)) ? (w(), A("div", {
              key: 0,
              class: J(["relative", Et(ve) ? "group/middle-tp" : ""])
            }, [
              K.value.length === 1 ? (w(), A("div", {
                key: 0,
                ref_for: !0,
                ref_key: "interventionNameRef",
                ref: Ae,
                class: J(["absolute -top-5 left-1/2 -translate-x-1/2 max-w-20 h-5 flex items-center justify-center overflow-hidden", [h(a) === "edit" ? "cursor-pointer" : "cursor-default"]]),
                onClick: Z[1] || (Z[1] = Se((xe) => h(a) === "edit" ? O.value = !0 : void 0, ["stop"]))
              }, [
                p("span", {
                  class: J(["text-[10px] font-medium truncate", rt.value.interventionName])
                }, ne(Tt.value), 3)
              ], 2)) : q("", !0),
              Q(bn, {
                ref_for: !0,
                ref: (xe) => h(D)(j.id, xe),
                "has-exposure": !0,
                "show-arrow": !1,
                label: nn(ve),
                color: e.colorIndex,
                "can-delete": h(a) === "edit" && on(ve),
                "is-hovered": h(z)(j.id),
                "is-directly-hovered": h(X)(j.id),
                "is-baseline": !1,
                "participant-count": j.participantCount ?? 0,
                "is-merged": ve === 0 && j.isStart && h(mt),
                "secondary-color": ve === 0 && j.isStart && h(mt) ? h(Jt)(ve) : void 0,
                "is-selected": gt(j.id),
                "is-selectable": y.value,
                "is-highlighted": H(j.id),
                "is-middle": Et(ve),
                onClick: (xe) => R(j.id),
                onClearExposure: (xe) => ln(j.id),
                onEditCount: (xe) => h(a) === "edit" ? h(te)(j.id) : void 0,
                onEditName: (xe) => h(a) === "edit" ? h(ee)(j.id) : void 0,
                onMouseenter: (xe) => h(a) === "edit" ? h(U)(j.id) : void 0,
                onMouseleave: Z[2] || (Z[2] = (xe) => h(a) === "edit" ? h(_)() : void 0)
              }, null, 8, ["label", "color", "can-delete", "is-hovered", "is-directly-hovered", "participant-count", "is-merged", "secondary-color", "is-selected", "is-selectable", "is-highlighted", "is-middle", "onClick", "onClearExposure", "onEditCount", "onEditName", "onMouseenter"])
            ], 2)) : q("", !0),
            h(a) === "edit" && K.value.length === 1 && ve === 0 ? (w(), A("button", {
              key: 1,
              class: "size-16 text-gray-600 relative cursor-pointer rounded-full flex items-center justify-center transition-all border-2 border-dashed border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 shrink-0 z-0",
              title: "Add Timepoint",
              onClick: Se((xe) => At(j.id), ["stop"])
            }, [
              Q(wt)
            ], 8, Mr)) : q("", !0),
            ve < K.value.length - 1 ? (w(), A("div", Ar, [
              p("button", {
                ref_for: !0,
                ref: (xe) => h(N)(j.id, xe),
                class: J(["w-24 h-4 transition-all relative group", [h(a) === "edit" ? "cursor-pointer" : "cursor-default"]]),
                onClick: (xe) => h(a) === "edit" ? h(Xt)(j.id) : void 0
              }, [
                j.duration ? (w(), A("div", Rr, ne(h(Pt)(j.duration)), 1)) : h(a) === "edit" ? (w(), A("div", Dr, [
                  Q(Cn)
                ])) : q("", !0),
                p("div", {
                  class: J(["absolute w-[120%] h-full top-0 -left-2 z-1", Qt.value])
                }, null, 2)
              ], 10, Br),
              h(a) === "edit" && (ve === K.value.length - 2 || K.value.length === 1 && ve === 0) ? (w(), A("button", {
                key: 0,
                class: "size-9 cursor-pointer text-gray-600 rounded-full flex items-center justify-center transition-all border-2 border-dashed border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 shrink-0 absolute left-1/2 -translate-x-1/2 top-6",
                title: "Add Timepoint",
                onClick: Z[3] || (Z[3] = (xe) => At(
                  K.value[K.value.length - 2]?.id ?? K.value[0]?.id ?? null
                ))
              }, [
                Q(wt)
              ])) : q("", !0)
            ])) : q("", !0)
          ], 64))), 128))
        ])
      ]),
      e.isFirstIntervention && !h(Ke) ? (w(), A("div", Lr, [
        p("button", {
          ref: (j) => h(G)(j),
          class: J(["w-24 h-1 transition-all bg-transparent border-t-4 border-gray-600 relative group flex items-center justify-center", h(a) === "edit" ? "cursor-pointer" : "cursor-default"]),
          onClick: Z[4] || (Z[4] = (j) => h(a) === "edit" ? h(Gt)() : void 0)
        }, [
          p("div", Nr, [
            kt()?.duration ? (w(), A("div", Pr, ne(h(Pt)(kt().duration)), 1)) : (w(), A("div", Vr, [
              Q(Xn)
            ]))
          ])
        ], 2)
      ])) : q("", !0),
      e.nextIntervention && !h(qt) ? (w(), A("div", Or, [
        p("button", {
          ref: (j) => h(W)(j),
          class: J(["w-24 h-1 transition-all bg-transparent border-t-4 border-gray-600 relative group flex items-center justify-center", h(a) === "edit" ? "cursor-pointer" : "cursor-default"]),
          onClick: Z[5] || (Z[5] = (j) => h(a) === "edit" ? h(pt)() : void 0)
        }, [
          p("div", Hr, [
            Mt()?.duration ? (w(), A("div", Fr, ne(h(Pt)(Mt().duration)), 1)) : (w(), A("div", zr, [
              Q(Xn)
            ]))
          ])
        ], 2)
      ])) : q("", !0),
      e.previousIntervention && h(mt) && h(a) === "edit" ? (w(), A("button", {
        key: 2,
        ref: (j) => {
          L.value = j;
        },
        class: "absolute -inset-1 size-6 bg-slate-200 rounded-full flex items-center justify-center z-20 hover:bg-slate-300 cursor-pointer",
        onClick: Z[6] || (Z[6] = //@ts-ignore
        (...j) => h(pt) && h(pt)(...j))
      }, [
        Q(Cn)
      ], 512)) : q("", !0),
      h(S) && h(a) === "edit" ? (w(), oe(wn, {
        key: 3,
        "reference-el": h(se).get(h(S))?.$el || null,
        name: h(b),
        "rename-all": h(P),
        "onUpdate:name": Z[7] || (Z[7] = (j) => b.value = j),
        "onUpdate:renameAll": Z[8] || (Z[8] = (j) => P.value = j),
        onSave: h(le),
        onCancel: h(ie)
      }, null, 8, ["reference-el", "name", "rename-all", "onSave", "onCancel"])) : q("", !0),
      h(C) && h(a) === "edit" ? (w(), oe(yn, {
        key: 4,
        "reference-el": h(se).get(h(C))?.$el || null,
        value: h(B),
        "onUpdate:value": Z[9] || (Z[9] = (j) => B.value = j),
        onSave: h(re),
        onClear: h(me),
        onCancel: h(Me)
      }, null, 8, ["reference-el", "value", "onSave", "onClear", "onCancel"])) : q("", !0),
      h(Be) && h(a) === "edit" ? (w(), oe(ho, {
        key: 5,
        "reference-el": h(ft),
        "can-merge-duration": h(St),
        operator: h(he),
        value1: h(We),
        value2: h(ye),
        unit: h(we),
        units: h(xo),
        "onUpdate:operator": Z[10] || (Z[10] = (j) => he.value = j),
        "onUpdate:value1": Z[11] || (Z[11] = (j) => We.value = j),
        "onUpdate:value2": Z[12] || (Z[12] = (j) => ye.value = j),
        "onUpdate:unit": Z[13] || (Z[13] = (j) => we.value = j),
        onSave: h(Yt),
        onClear: h(_t),
        onCancel: h(Kt)
      }, null, 8, ["reference-el", "can-merge-duration", "operator", "value1", "value2", "unit", "units", "onSave", "onClear", "onCancel"])) : q("", !0),
      h(O) && h(a) === "edit" ? (w(), oe(ar, {
        key: 6,
        "reference-el": h(Ae),
        intervention: e.intervention,
        onClose: Z[14] || (Z[14] = (j) => O.value = !1),
        onDelete: rn
      }, null, 8, ["reference-el", "intervention"])) : q("", !0)
    ], 2));
  }
}), jr = { class: "p-4 min-w-100" }, Ur = { class: "text-sm font-medium text-slate-700 mb-3" }, Wr = { class: "space-y-4" }, qr = {
  key: 0,
  class: "space-y-1 overflow-y-auto"
}, Xr = ["onClick"], Gr = { class: "text-sm text-slate-700" }, Yr = { class: "border-t border-slate-200 pt-3" }, _r = { class: "flex gap-2" }, Kr = ["disabled"], Jr = { class: "flex justify-end gap-2 pt-2" }, Qr = ["disabled"], es = /* @__PURE__ */ ae({
  __name: "ExposureSelectPopup",
  props: {
    referenceEl: {},
    title: {}
  },
  emits: ["close", "select"],
  setup(e, { emit: t }) {
    const n = t, { exposures: o, addExposure: i, getExposureColorIndex: r } = Ue(), l = M(""), s = M([]);
    vt(() => {
      V.user("Exposure Select Popup opened");
    });
    function d(c) {
      const a = s.value.indexOf(c);
      a > -1 ? s.value.splice(a, 1) : s.value.push(c);
    }
    async function u() {
      if (!l.value.trim()) return;
      V.user("Creating new exposure from popup", { name: l.value });
      const c = {
        id: Date.now().toString(),
        name: l.value.trim(),
        characteristics: []
      };
      i(c), l.value = "", await Vt();
    }
    function m() {
      V.user("Saving exposure selection from popup", {
        exposureIds: s.value
      }), n("select", s.value);
    }
    return (c, a) => (w(), oe(je, {
      "reference-el": e.referenceEl,
      onClose: a[1] || (a[1] = (f) => c.$emit("close"))
    }, {
      default: Pe(() => [
        p("div", jr, [
          p("h3", Ur, ne(e.title), 1),
          p("div", Wr, [
            p("div", null, [
              a[2] || (a[2] = p("div", { class: "block text-xs font-medium text-slate-600 mb-2" }, " Select Exposures (one or more) ", -1)),
              h(o).length > 0 ? (w(), A("div", qr, [
                (w(!0), A(de, null, pe(h(o), (f) => (w(), A("button", {
                  key: f.id,
                  class: J([
                    "w-full text-left px-3 py-2 rounded-lg transition-colors flex items-center gap-2",
                    s.value.includes(f.id) ? "bg-blue-100 border-2 border-blue-500" : "hover:bg-slate-100 border-2 border-transparent"
                  ]),
                  onClick: (v) => d(f.id)
                }, [
                  p("div", {
                    class: J(["w-3 h-3 rounded-full", h($e)[h(r)(f.id)]?.inner])
                  }, null, 2),
                  p("span", Gr, ne(f.name), 1)
                ], 10, Xr))), 128))
              ])) : q("", !0)
            ]),
            p("div", Yr, [
              p("div", _r, [
                ke(p("input", {
                  "onUpdate:modelValue": a[0] || (a[0] = (f) => l.value = f),
                  type: "text",
                  placeholder: "New exposure name...",
                  class: "flex-1 h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
                  onKeyup: nt(u, ["enter"])
                }, null, 544), [
                  [Ze, l.value]
                ]),
                p("button", {
                  class: "px-3 py-1 bg-blue-500 text-white rounded-lg text-sm hover:bg-blue-600 transition-colors disabled:opacity-50",
                  disabled: !l.value.trim(),
                  onClick: u
                }, " Create ", 8, Kr)
              ])
            ]),
            p("div", Jr, [
              p("button", {
                class: "px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700 transition-colors disabled:opacity-50",
                disabled: s.value.length === 0,
                onClick: m
              }, " Save ", 8, Qr)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"]));
  }
}), ts = { class: "p-4 w-75 space-y-4" }, ns = { class: "flex gap-2 pt-2" }, os = /* @__PURE__ */ ae({
  __name: "ArmMenu",
  props: {
    armId: {},
    armName: {},
    referenceEl: {}
  },
  emits: ["close", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = M(n.armName);
    ce(
      () => n.armName,
      (l) => {
        i.value = l;
      }
    );
    function r() {
      o("save", i.value.trim()), o("close");
    }
    return (l, s) => (w(), oe(je, {
      "reference-el": e.referenceEl,
      onClose: s[2] || (s[2] = (d) => l.$emit("close"))
    }, {
      default: Pe(() => [
        p("div", ts, [
          p("div", null, [
            s[3] || (s[3] = p("label", {
              for: "arm-name",
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "Name", -1)),
            ke(p("input", {
              id: "arm-name",
              "onUpdate:modelValue": s[0] || (s[0] = (d) => i.value = d),
              type: "text",
              class: "h-9 w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
              placeholder: "Enter name..."
            }, null, 512), [
              [Ze, i.value]
            ])
          ]),
          p("div", ns, [
            p("button", {
              class: "flex-1 h-9 rounded-lg bg-blue-600 text-white font-medium text-sm hover:bg-blue-700 transition-colors",
              onClick: r
            }, " Save "),
            p("button", {
              class: "h-9 px-4 rounded-lg bg-red-600 text-white font-medium text-sm hover:bg-red-700 transition-colors",
              onClick: s[1] || (s[1] = (d) => l.$emit("delete"))
            }, " Delete ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"]));
  }
}), is = {}, ls = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "currentColor"
};
function rs(e, t) {
  return w(), A("svg", ls, [...t[0] || (t[0] = [
    p("path", { d: "M221-144.87q-48.04 0-69.05-42.16-21.02-42.17 8.81-79.21l197.11-238.63V-734.5h-29.38q-16.08 0-27.4-11.16-11.31-11.15-11.31-27.32t11.16-27.85q11.17-11.67 27.34-11.67h304.44q16.17 0 27.34 11.39 11.16 11.39 11.16 27.9 0 16.09-11.16 27.4-11.17 11.31-27.34 11.31h-29.59v229.63l196.09 238.85q28.85 36.82 8.06 78.99-20.78 42.16-67.28 42.16H221Zm6.22-78h506.56L525.13-478.63V-734.5h-89.26v255.7L227.22-222.87ZM481.5-478.8Z" }, null, -1)
  ])]);
}
const ss = /* @__PURE__ */ ge(is, [["render", rs]]), as = { class: "flex items-center py-8" }, us = ["title"], cs = { class: "relative flex items-center" }, ds = {
  key: 0,
  class: "z-20"
}, vs = {
  key: 1,
  class: "relative z-20"
}, fs = { class: "flex items-center" }, ps = {
  key: 0,
  class: "flex flex-col gap-1 ml-4"
}, ms = {
  key: 1,
  class: "flex flex-col gap-1"
}, gs = /* @__PURE__ */ ae({
  __name: "Arm",
  props: {
    arm: {},
    colorIndex: {},
    showArmName: { type: Boolean }
  },
  emits: ["delete"],
  setup(e) {
    const t = e, {
      getInterventionsForArm: n,
      addIntervention: o,
      removeIntervention: i,
      getExposureColorIndex: r,
      updateIntervention: l,
      interventionsDataEntity: s,
      updateArm: d,
      updateArmBaselineName: u,
      baselineName: m,
      mode: c,
      selectedTimepointNames: a,
      toggleTimepointSelection: f,
      selectedInterventionIds: v,
      commonTimepointNamesInSelectedInterventions: T,
      hoveredTimepointId: $,
      setHoveredTimepoint: E
    } = Ue(), x = k(() => n(t.arm.id)), g = k(() => x.value.length > 0), y = M(!1), S = M(!1), b = M(null), C = M(null), B = M(null), O = M(null), P = M(null), U = M(!1), _ = M(void 0), z = M(!1), X = M(void 0), ee = M(!1), le = M(fe.EXACT), ie = M(0), te = M(0), re = M("days"), me = M(!1), Me = M(""), se = M(!1), be = M(""), ue = M(!1), He = M(!1), Ae = M(!1), I = k(() => $.value ? $.value === m.value : !0), L = k(() => {
      if (!$.value) return !0;
      const H = G.value?.name ?? "Start";
      return $.value === H;
    }), D = k(() => s.value.filter((R) => R.armId === t.arm.id).sort((R, F) => R.order.localeCompare(F.order))[0]), N = k(() => D.value?.timepoints.find((H) => H.isBaseline)), G = k(() => D.value?.timepoints.find((H) => H.isStart)), W = k(() => Ee(N.value?.duration)), K = k(() => g.value ? W.value ? G.value?.participantCount ?? 0 : N.value?.participantCount ?? 0 : t.arm.participantsCount ?? 0), Be = k(() => G.value?.participantCount ?? 0), he = k(() => !D.value || !D.value.exposureIds[0] ? t.colorIndex : r(D.value.exposureIds[0])), We = k(() => c.value !== "select" || !D.value || !v.value.includes(D.value.id) ? !1 : a.value.includes(m.value)), ye = k(() => c.value !== "select" || a.value.length === 0 || v.value.length === 2 && a.value.length === 2 || !D.value || We.value ? !1 : v.value.includes(
      D.value.id
    ) ? T.value.includes(m.value) : v.value.length === 2 ? !1 : a.value.includes(m.value) ? !0 : a.value.length === 1 ? T.value.includes(m.value) : !1), we = k(() => {
      if (c.value === "select")
        return !0;
    }), ft = k(() => {
      if (c.value !== "select" || !D.value || !v.value.includes(D.value.id)) return !1;
      const H = G.value?.name ?? "Start";
      return a.value.includes(H);
    }), St = k(() => {
      if (c.value !== "select" || a.value.length === 0 || v.value.length === 2 && a.value.length === 2 || !D.value) return !1;
      const H = G.value?.name ?? "Start";
      return ft.value ? !1 : v.value.includes(
        D.value.id
      ) ? T.value.includes(H) : v.value.length === 2 ? !1 : a.value.includes(H) ? !0 : a.value.length === 1 ? T.value.includes(H) : !1;
    }), Ke = k(() => {
      if (c.value === "select")
        return !0;
    });
    function qt(H) {
      H && H !== t.arm.name && d(t.arm.id, { name: H });
    }
    function Xt() {
      U.value = !0, _.value = K.value;
    }
    function Gt() {
      z.value = !0, X.value = Be.value;
    }
    function pt() {
      V.user("Started editing baseline name"), me.value = !0, Me.value = m.value, ue.value = !1;
    }
    function Yt() {
      V.user("Started editing start name"), se.value = !0, be.value = G.value?.name ?? "Start", ue.value = !1;
    }
    function _t() {
      const H = Me.value.trim();
      V.user("Saved global baseline name", {
        newName: H
      }), u("", H), me.value = !1, Me.value = "";
    }
    function Kt() {
      if (!D.value || !G.value || !be.value.trim())
        return;
      const H = D.value.timepoints.map(
        (R) => R.id === G.value.id ? { ...R, name: be.value.trim() } : R
      );
      l(D.value.id, {
        timepoints: H
      }), se.value = !1, be.value = "";
    }
    function mt() {
      V.user("Clicked edit baseline duration (merged state)");
      const H = N.value?.duration;
      H ? (le.value = H.operator, ie.value = H.value1 || 0, te.value = H.value2 || 0, re.value = H.unit || "days") : (le.value = fe.EXACT, ie.value = 0, te.value = 0, re.value = "days"), ee.value = !0;
    }
    function It() {
      if (!D.value || !N.value) return;
      const H = {
        operator: le.value,
        value1: ie.value,
        value2: le.value === fe.BETWEEN ? te.value : void 0,
        unit: re.value
      }, R = D.value.timepoints.map(
        (F) => F.id === N.value.id ? { ...F, duration: H } : F
      );
      l(D.value.id, {
        timepoints: R
      }), ee.value = !1;
    }
    function Jt() {
      if (!D.value || !N.value) return;
      const H = D.value.timepoints.map(
        (R) => R.id === N.value.id ? { ...R, duration: void 0 } : R
      );
      l(D.value.id, {
        timepoints: H
      }), ee.value = !1;
    }
    function rt() {
      if (!g.value) {
        d(t.arm.id, {
          participantsCount: _.value ?? 0
        }), U.value = !1, _.value = void 0;
        return;
      }
      if (!D.value) return;
      const H = W.value ? G.value : N.value;
      if (!H) return;
      const R = D.value.timepoints.map(
        (F) => F.id === H.id ? { ...F, participantCount: _.value } : F
      );
      l(D.value.id, {
        timepoints: R
      }), U.value = !1, _.value = void 0;
    }
    function Qt() {
      if (!g.value) {
        d(t.arm.id, { participantsCount: 0 }), U.value = !1, _.value = void 0;
        return;
      }
      if (!D.value) return;
      const H = W.value ? G.value : N.value;
      if (!H) return;
      const R = D.value.timepoints.map(
        (F) => F.id === H.id ? { ...F, participantCount: void 0 } : F
      );
      l(D.value.id, {
        timepoints: R
      }), U.value = !1, _.value = void 0;
    }
    function Tt() {
      if (!D.value || !G.value) return;
      const H = D.value.timepoints.map(
        (R) => R.id === G.value.id ? { ...R, participantCount: X.value } : R
      );
      l(D.value.id, {
        timepoints: H
      }), z.value = !1, X.value = void 0;
    }
    function en() {
      if (!D.value || !G.value) return;
      const H = D.value.timepoints.map(
        (R) => R.id === G.value.id ? { ...R, participantCount: void 0 } : R
      );
      l(D.value.id, {
        timepoints: H
      }), z.value = !1, X.value = void 0;
    }
    function Et(H, R) {
      V.user("Exposure selected", {
        exposureId: H,
        armId: t.arm.id,
        afterInterventionId: R
      }), o(t.arm.id, [H], R);
    }
    function kt(H) {
      V.user("Duplicate intervention clicked", {
        armId: t.arm.id,
        afterInterventionId: H
      });
    }
    function Mt(H) {
      V.user("Remove intervention clicked", {
        interventionId: H,
        armId: t.arm.id
      }), i(H);
    }
    function tn(H) {
      V.user("Multiple exposures selected for arm", {
        armId: t.arm.id,
        exposureIds: H
      });
      const R = x.value[x.value.length - 1];
      o(t.arm.id, H, R?.id), y.value = !1;
    }
    function nn() {
      c.value === "edit" && (He.value = !0, E(m.value));
    }
    function on() {
      c.value === "edit" && (He.value = !1, E(null));
    }
    function At() {
      if (c.value === "edit") {
        Ae.value = !0;
        const H = G.value?.name ?? "Start";
        E(H);
      }
    }
    function ln() {
      c.value === "edit" && (Ae.value = !1, E(null));
    }
    function rn() {
      if (c.value === "select") {
        if (!we.value || !D.value || !N.value) return;
        const H = m.value;
        if (v.value.length > 0 && !ye.value && !We.value)
          return;
        f(D.value.id, H);
      } else
        Xt();
    }
    function gt() {
      if (c.value === "select") {
        if (!Ke.value || !D.value || !G.value) return;
        const H = G.value.name;
        if (v.value.length > 0 && !St.value && !ft.value)
          return;
        f(D.value.id, H);
      } else
        Gt();
    }
    return (H, R) => (w(), A("div", as, [
      p("button", {
        ref_key: "armNameButtonRef",
        ref: C,
        class: J(["text-xs w-11 truncate font-medium text-slate-600 mr-2 px-1.5 py-0.5 rounded transition-colors", h(c) === "edit" ? "hover:bg-slate-100 cursor-pointer" : "cursor-default"]),
        onClick: R[0] || (R[0] = Se((F) => h(c) === "edit" ? S.value = !0 : void 0, ["stop"])),
        title: e.arm.name
      }, ne(e.arm.name), 11, us),
      p("div", cs, [
        !g.value || !W.value ? (w(), A("div", ds, [
          Q(bn, {
            ref_key: "baselineCircleRef",
            ref: B,
            "has-exposure": !0,
            "show-arrow": !1,
            label: h(m) || "Baseline",
            color: e.colorIndex,
            "is-baseline": !0,
            "is-hovered": I.value,
            "is-directly-hovered": He.value,
            "participant-count": K.value,
            "is-selected": We.value,
            "is-selectable": we.value,
            "is-highlighted": ye.value,
            onClick: rn,
            onEditName: R[1] || (R[1] = (F) => h(c) === "edit" ? pt() : void 0),
            onMouseenter: R[2] || (R[2] = (F) => h(c) === "edit" ? nn() : He.value = !0),
            onMouseleave: R[3] || (R[3] = (F) => h(c) === "edit" ? on() : He.value = !1)
          }, null, 8, ["label", "color", "is-hovered", "is-directly-hovered", "participant-count", "is-selected", "is-selectable", "is-highlighted"])
        ])) : q("", !0),
        g.value && W.value ? (w(), A("div", vs, [
          h(c) === "edit" ? (w(), A("button", {
            key: 0,
            ref_key: "baselineMergedScheduleRef",
            ref: P,
            class: "absolute -inset-1 size-6 bg-slate-200 rounded-full flex items-center justify-center z-20 hover:bg-slate-300 cursor-pointer",
            onClick: mt
          }, [
            Q(Cn)
          ], 512)) : q("", !0),
          Q(bn, {
            ref_key: "startCircleRef",
            ref: O,
            "has-exposure": !0,
            "show-arrow": !1,
            label: G.value?.name ?? "Start",
            color: he.value,
            "is-baseline": !1,
            "is-hovered": L.value,
            "is-directly-hovered": Ae.value,
            "participant-count": Be.value,
            "is-merged": !0,
            "secondary-is-baseline": !0,
            "is-selected": ft.value,
            "is-selectable": Ke.value,
            "is-highlighted": St.value,
            onClick: gt,
            onEditName: R[4] || (R[4] = (F) => h(c) === "edit" ? Yt() : void 0),
            onMouseenter: R[5] || (R[5] = (F) => h(c) === "edit" ? At() : Ae.value = !0),
            onMouseleave: R[6] || (R[6] = (F) => h(c) === "edit" ? ln() : Ae.value = !1)
          }, null, 8, ["label", "color", "is-hovered", "is-directly-hovered", "participant-count", "is-selected", "is-selectable", "is-highlighted"])
        ])) : q("", !0),
        p("div", fs, [
          (w(!0), A(de, null, pe(x.value, (F, qe) => (w(), oe(Zr, {
            key: F.id,
            intervention: F,
            "color-index": h(r)(F.exposureIds[0] ?? ""),
            "is-first-intervention": qe === 0,
            "is-last-intervention": qe === x.value.length - 1,
            "previous-intervention": x.value[qe - 1],
            "next-intervention": x.value[qe + 1],
            onSelect: (ht) => Et(ht, F.id),
            onDuplicateFrom: (ht) => kt(F.id),
            onRemove: (ht) => Mt(F.id)
          }, null, 8, ["intervention", "color-index", "is-first-intervention", "is-last-intervention", "previous-intervention", "next-intervention", "onSelect", "onDuplicateFrom", "onRemove"]))), 128)),
          x.value.length > 0 && h(c) === "edit" ? (w(), A("div", ps, [
            p("button", {
              ref_key: "addInterventionButtonRef",
              ref: b,
              class: "size-9 text-gray-600 cursor-pointer rounded-full flex items-center justify-center transition-all border-2 border-dashed border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 shrink-0",
              title: "Add any exposure assessed in the study (e.g. treatment, diagnostic procedure, measurement, comparator or standard of care, environmental exposure).",
              onClick: R[7] || (R[7] = (F) => y.value = !0)
            }, [
              Q(ss, { class: "size-5" })
            ], 512)
          ])) : q("", !0),
          x.value.length === 0 && h(c) === "edit" ? (w(), A("div", ms, [
            p("button", {
              ref_key: "addInterventionButtonRef",
              ref: b,
              class: "size-16 rounded-full flex items-center justify-center transition-all border-2 border-dashed border-slate-300 bg-white hover:border-slate-400 hover:bg-slate-50 shrink-0 text-gray-600",
              title: "Add Intervention",
              onClick: R[8] || (R[8] = (F) => y.value = !0)
            }, [
              Q(wt)
            ], 512)
          ])) : q("", !0)
        ])
      ]),
      U.value && h(c) === "edit" ? (w(), oe(yn, {
        key: 0,
        "reference-el": B.value?.$el || null,
        value: _.value,
        "onUpdate:value": R[9] || (R[9] = (F) => _.value = F),
        onSave: rt,
        onClear: Qt,
        onCancel: R[10] || (R[10] = (F) => U.value = !1)
      }, null, 8, ["reference-el", "value"])) : q("", !0),
      z.value && h(c) === "edit" ? (w(), oe(yn, {
        key: 1,
        "reference-el": O.value?.$el || null,
        value: X.value,
        "onUpdate:value": R[11] || (R[11] = (F) => X.value = F),
        onSave: Tt,
        onClear: en,
        onCancel: R[12] || (R[12] = (F) => z.value = !1)
      }, null, 8, ["reference-el", "value"])) : q("", !0),
      ee.value && h(c) === "edit" ? (w(), oe(ho, {
        key: 2,
        "reference-el": P.value,
        "can-merge-duration": !0,
        operator: le.value,
        value1: ie.value,
        value2: te.value,
        unit: re.value,
        units: h(xo),
        "onUpdate:operator": R[13] || (R[13] = (F) => le.value = F),
        "onUpdate:value1": R[14] || (R[14] = (F) => ie.value = F),
        "onUpdate:value2": R[15] || (R[15] = (F) => te.value = F),
        "onUpdate:unit": R[16] || (R[16] = (F) => re.value = F),
        onSave: It,
        onClear: Jt,
        onCancel: R[17] || (R[17] = (F) => ee.value = !1)
      }, null, 8, ["reference-el", "operator", "value1", "value2", "unit", "units"])) : q("", !0),
      me.value && h(c) === "edit" ? (w(), oe(wn, {
        key: 3,
        "reference-el": B.value?.$el || null,
        name: Me.value,
        "rename-all": ue.value,
        "is-baseline": !0,
        "onUpdate:name": R[18] || (R[18] = (F) => Me.value = F),
        "onUpdate:renameAll": R[19] || (R[19] = (F) => ue.value = F),
        onSave: _t,
        onCancel: R[20] || (R[20] = (F) => me.value = !1)
      }, null, 8, ["reference-el", "name", "rename-all"])) : q("", !0),
      se.value && h(c) === "edit" ? (w(), oe(wn, {
        key: 4,
        "reference-el": O.value?.$el || null,
        name: be.value,
        "rename-all": ue.value,
        "onUpdate:name": R[21] || (R[21] = (F) => be.value = F),
        "onUpdate:renameAll": R[22] || (R[22] = (F) => ue.value = F),
        onSave: Kt,
        onCancel: R[23] || (R[23] = (F) => se.value = !1)
      }, null, 8, ["reference-el", "name", "rename-all"])) : q("", !0),
      y.value && h(c) === "edit" ? (w(), oe(es, {
        key: 5,
        "reference-el": b.value,
        title: "Select Exposures for Intervention",
        onClose: R[24] || (R[24] = (F) => y.value = !1),
        onSelect: tn
      }, null, 8, ["reference-el"])) : q("", !0),
      S.value && h(c) === "edit" ? (w(), oe(os, {
        key: 6,
        "arm-id": e.arm.id,
        "arm-name": e.arm.name,
        "reference-el": C.value,
        onClose: R[25] || (R[25] = (F) => S.value = !1),
        onSave: qt,
        onDelete: R[26] || (R[26] = (F) => H.$emit("delete"))
      }, null, 8, ["arm-id", "arm-name", "reference-el"])) : q("", !0)
    ]));
  }
}), hs = { class: "flex items-center w-full" }, xs = { class: "relative flex items-center w-full gap-48" }, bs = { class: "flex flex-col items-center z-10" }, ys = /* @__PURE__ */ ae({
  __name: "PopulationSet",
  props: {
    population: {},
    baseArmIndex: {}
  },
  setup(e) {
    const t = e, {
      removePopulation: n,
      updatePopulation: o,
      addArm: i,
      removeArm: r,
      getInterventionsForArm: l,
      armsDataEntity: s,
      interventionsDataEntity: d,
      mode: u
    } = Ue(), m = M(!1), c = M(null), a = M(null), f = M(null), v = k(() => c.value?.$el?.querySelector(".size-48") ?? null), T = k(() => c.value?.$el ?? null);
    ce(
      () => t.population.arms?.length,
      () => {
        Vt(() => {
          f.value?.recalculate();
        });
      }
    );
    const $ = k(() => !t.population.arms || t.population.arms.length === 0 ? !1 : t.population.arms.some((S) => l(S.id).length > 0));
    function E(S) {
      const b = d.value.filter((P) => P.armId === S).sort((P, U) => P.order.localeCompare(U.order));
      if (b.length === 0) return 0;
      const C = b[0], B = C.timepoints.find((P) => P.isBaseline), O = C.timepoints.find((P) => P.isStart);
      return B && O && Ee(O.duration) ? O.participantCount ?? 0 : B ? B.participantCount ?? 0 : 0;
    }
    const x = k(() => s.value.filter((b) => b.populationId === t.population.id).map((b) => b.id).reduce((b, C) => b + E(C), 0));
    function g() {
      V.user("Clicked Add Arm", { parentId: t.population.id }), i({
        id: Date.now().toString(),
        name: "",
        participantsCount: 0,
        populationId: t.population.id
      });
    }
    function y(S) {
      V.user("Clicked Delete Arm", { armId: S, parentId: t.population.id }), r(S);
    }
    return (S, b) => (w(), A("div", hs, [
      p("div", xs, [
        p("div", bs, [
          Q(Do, {
            ref_key: "populationIconRef",
            ref: c,
            name: e.population.name,
            count: x.value,
            color: e.population.color,
            "show-delete": h(u) === "edit",
            onDelete: b[0] || (b[0] = () => {
              h(V).user("Clicked Delete Population", { id: e.population.id }), h(n)(e.population.id);
            }),
            onClick: b[1] || (b[1] = () => {
              h(u) === "edit" && (h(V).user("Toggled Population Menu", { id: e.population.id, show: !m.value }), m.value = !m.value);
            })
          }, null, 8, ["name", "count", "color", "show-delete"]),
          m.value && h(u) === "edit" ? (w(), oe(bl, {
            key: 0,
            "population-id": e.population.id,
            "reference-el": T.value,
            onClose: b[2] || (b[2] = (C) => m.value = !1)
          }, null, 8, ["population-id", "reference-el"])) : q("", !0)
        ]),
        Q(Al, {
          ref_key: "splittingArrowRef",
          ref: f,
          "population-icon-ref": v.value,
          "arms-container-ref": a.value,
          "arm-count": e.population.arms?.length ?? 1,
          color: e.population.color,
          "population-id": e.population.id,
          "is-randomized": e.population.isRandomized,
          "show-add-arm": h(u) === "edit",
          "onUpdate:isRandomized": b[3] || (b[3] = (C) => h(o)(e.population.id, { isRandomized: C })),
          onAddArm: g
        }, null, 8, ["population-icon-ref", "arms-container-ref", "arm-count", "color", "population-id", "is-randomized", "show-add-arm"]),
        p("div", {
          ref_key: "armsContainerRef",
          ref: a,
          class: J(e.population.arms && e.population.arms.length > 1 ? "space-y-24" : "")
        }, [
          (w(!0), A(de, null, pe(e.population.arms, (C, B) => (w(), oe(gs, {
            key: C.id,
            arm: C,
            "color-index": (e.baseArmIndex ?? 0) + B,
            "show-arm-name": $.value && e.population.arms && e.population.arms.length > 1,
            onDelete: (O) => y(C.id)
          }, null, 8, ["arm", "color-index", "show-arm-name", "onDelete"]))), 128))
        ], 2)
      ])
    ]));
  }
}), ws = {}, Cs = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "30px",
  viewBox: "0 -960 960 960",
  width: "30px",
  fill: "currentColor"
};
function $s(e, t) {
  return w(), A("svg", Cs, [...t[0] || (t[0] = [
    p("path", { d: "M449.39-486.54q27.15-30.42 41.62-67.57 14.47-37.15 14.47-76.21 0-38.7-14.7-75.89-14.69-37.18-41.87-67.64 8-2 15-2.5t15-.5q61.33 1.91 101.45 45.18 40.12 43.26 40.12 101.47 0 59.18-40.36 102.2t-100.73 44.46q-8 0-15.5-.5t-14.5-2.5ZM650.48-192.8v-92.68q0-42.74-17.76-77.99-17.76-35.25-52.2-60.68 69.77 14.2 129.53 44.12 59.75 29.92 59.75 94.72v92.51H650.48Zm130.61-247.68v-83.72h-83.72v-67h83.72v-83.71h67v83.71h83.71v67h-83.71v83.72h-67Zm-489.5-42.59q-62.09 0-104.61-42.52-42.52-42.52-42.52-104.61 0-62.08 42.52-104.49 42.52-42.4 104.61-42.4 62.08 0 104.49 42.4 42.4 42.41 42.4 104.49 0 62.09-42.4 104.61-42.41 42.52-104.49 42.52ZM4.46-192.8v-94.61q0-26.64 12.82-48.56 12.83-21.92 36.5-36.39 53.94-33.23 114.8-49.22 60.87-15.99 122.55-15.99 62.39 0 122.6 16.87 60.2 16.87 115.42 48.1 22.68 14.47 36 36.31 13.33 21.84 13.33 48.86v94.63H4.46Zm286.62-368.27q28.31 0 48.85-20.15 20.55-20.16 20.55-48.47t-20.59-48.85q-20.59-20.55-48.8-20.55-28.31 0-48.47 20.59t-20.16 48.8q0 28.31 20.16 48.47 20.15 20.16 48.46 20.16ZM82.46-270.8h418.02v-15.42q0-6.02-3-10.95-3-4.94-8.5-8.83-46.07-24.78-95.52-39.17-49.46-14.4-102.31-14.4-53.2 0-102.9 14.02-49.71 14.01-94.29 39.55-5.5 3.89-8.5 8.83-3 4.93-3 10.95v15.42Zm209.13-359.4Zm0 359.4Z" }, null, -1)
  ])]);
}
const Ss = /* @__PURE__ */ ge(ws, [["render", $s]]), Is = { class: "flex items-start relative" }, Ts = { class: "flex-1" }, Es = /* @__PURE__ */ ae({
  __name: "Population",
  setup(e) {
    const { populations: t, addPopulation: n, mode: o } = Ue();
    ce(
      t,
      (l) => {
        V.computed("Populations updated", {
          count: l.length,
          totalArms: l.reduce((s, d) => s + (d.arms?.length || 1), 0)
        });
      },
      { deep: !0 }
    );
    function i(l) {
      let s = 0;
      for (let d = 0; d < l; d++) {
        const u = t.value[d];
        u?.arms?.length ? s += u.arms.length : s += 1;
      }
      return s;
    }
    function r() {
      V.user("Clicked Add Population"), n({ id: Date.now().toString(), name: "" });
    }
    return (l, s) => (w(), A("div", null, [
      p("div", null, [
        p("div", Is, [
          p("div", Ts, [
            (w(!0), A(de, null, pe(h(t), (d, u) => (w(), A("div", {
              key: d.id,
              class: "border-b border-slate-300 pt-24 pb-8"
            }, [
              Q(ys, {
                population: d,
                "base-arm-index": i(u)
              }, null, 8, ["population", "base-arm-index"])
            ]))), 128))
          ])
        ])
      ]),
      h(o) === "edit" ? (w(), A("button", {
        key: 0,
        class: "mt-24 flex items-center gap-1 text-slate-600 hover:text-blue-600 hover:bg-blue-50 hover:scale-110 transition-all rounded-lg px-2 py-1",
        title: "Add Population",
        onClick: r
      }, [
        Q(Ss)
      ])) : q("", !0)
    ]));
  }
}), ks = {}, Ms = { class: "w-18 shrink-0 relative border-r border-gray-200 z-101 mr-10 bg-white" };
function As(e, t) {
  return w(), A("div", Ms, [...t[0] || (t[0] = [
    p("div", { class: "absolute left-4 top-5 rounded-full font-semibold bg-white drop-shadow-md px-3.5 py-3 whitespace-nowrap" }, " STUDY START ", -1)
  ])]);
}
const Bs = /* @__PURE__ */ ge(ks, [["render", As]]), Rs = {}, Ds = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function Ls(e, t) {
  return w(), A("svg", Ds, [...t[0] || (t[0] = [
    p("path", { d: "M409.5-39.61q-29.99 0-56.19-13.86t-43.44-38.57L57.3-464.74l23.8-21.9q19.1-18.1 45.46-21.22 26.36-3.12 50.14 13.29l110.19 76.59v-379.06q0-16.7 11.96-28.66 11.95-11.95 28.65-11.95t28.65 11.95q11.96 11.96 11.96 28.66v532.63l-149.02-104.2 158.04 230.22q5.06 7.73 13.77 12.64 8.71 4.92 18.6 4.92h268.02q32.84 0 56.12-23.27 23.27-23.28 23.27-56.12v-557.3q0-16.7 11.96-28.65 11.96-11.96 28.65-11.96 16.7 0 28.65 11.96 11.96 11.95 11.96 28.65v557.3q0 66.94-46.84 113.77-46.83 46.84-113.77 46.84H409.5Zm34.07-439.78v-399.57q0-16.69 11.95-28.65 11.96-11.96 28.65-11.96 16.7 0 28.66 11.96 11.95 11.96 11.95 28.65v399.57h-81.21Zm156.67 0v-358.13q0-16.7 11.96-28.65 11.95-11.96 28.65-11.96 16.69 0 28.65 11.96 11.96 11.95 11.96 28.65v358.13h-81.22ZM488-300.11Z" }, null, -1)
  ])]);
}
const Ns = /* @__PURE__ */ ge(Rs, [["render", Ls]]), Ps = {}, Vs = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function Os(e, t) {
  return w(), A("svg", Vs, [...t[0] || (t[0] = [
    p("path", { d: "M121.87-121.87v-208.35h86v122.35h122.35v86H121.87Zm508.65 0v-86h121.61v-122.35h86v208.35H630.52ZM121.87-630.52v-207.61h208.35v86H207.87v121.61h-86Zm630.26 0v-121.61H630.52v-86h207.61v207.61h-86Z" }, null, -1)
  ])]);
}
const Hs = /* @__PURE__ */ ge(Ps, [["render", Os]]), Fs = {}, zs = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function Zs(e, t) {
  return w(), A("svg", zs, [...t[0] || (t[0] = [
    p("path", { d: "M244.22-121.87v-122.35H121.87v-86h208.35v208.35h-86Zm386.3 0v-208.35h207.61v86H716.52v122.35h-86ZM121.87-630.52v-86h122.35v-121.61h86v207.61H121.87Zm508.65 0v-207.61h86v121.61h121.61v86H630.52Z" }, null, -1)
  ])]);
}
const js = /* @__PURE__ */ ge(Fs, [["render", Zs]]), Us = {}, Ws = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function qs(e, t) {
  return w(), A("svg", Ws, [...t[0] || (t[0] = [
    p("path", { d: "M480-327.87 277.02-530.85l59.89-60.41L437-490.94v-307.19h86v307.19l100.09-100.32 59.89 60.41L480-327.87Zm-232.13 166q-35.72 0-60.86-25.14t-25.14-60.86v-117.5h86v117.5h464.26v-117.5h86v117.5q0 35.72-25.14 60.86t-60.86 25.14H247.87Z" }, null, -1)
  ])]);
}
const Xs = /* @__PURE__ */ ge(Us, [["render", qs]]), Gs = {}, Ys = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function _s(e, t) {
  return w(), A("svg", Ys, [...t[0] || (t[0] = [
    p("path", { d: "M437-327.87v-307.19L336.91-534.74l-59.89-60.41L480-798.13l202.98 202.98-59.89 60.41L523-635.06v307.19h-86Zm-189.13 166q-35.72 0-60.86-25.14t-25.14-60.86v-117.5h86v117.5h464.26v-117.5h86v117.5q0 35.72-25.14 60.86t-60.86 25.14H247.87Z" }, null, -1)
  ])]);
}
const Ks = /* @__PURE__ */ ge(Gs, [["render", _s]]), Js = { class: "flex flex-col w-full min-h-0 relative" }, Qs = {
  key: 0,
  class: "flex items-center justify-between p-2 border-b border-slate-200 bg-slate-50"
}, ea = { class: "flex items-center gap-2" }, ta = ["title"], na = ["title"], oa = {
  key: 0,
  class: "flex items-center gap-2 px-4"
}, ia = { class: "text-sm text-slate-700 font-medium" }, la = /* @__PURE__ */ ae({
  __name: "Builder",
  props: {
    isFullScreen: { type: Boolean }
  },
  emits: ["toggleFullScreen", "export", "importClick"],
  setup(e, { emit: t }) {
    const n = Ue(), {
      mode: o,
      selectedTimepointNames: i,
      selectedInterventionIds: r,
      interventionsDataEntity: l,
      getExposureById: s
    } = n, d = t, u = M(null), m = M(!1), c = M(!1), a = M(!1), f = M(0), v = M(0), T = M(0), $ = M(0), E = k(() => l.value.filter((z) => r.value.includes(z.id))), x = k(() => E.value.map((z) => z.exposureIds.map((ee) => s(ee)?.name).filter(Boolean).join(", ") || "Unnamed Intervention")), g = k(() => {
      if (i.value.length === 0 && r.value.length === 0)
        return "";
      const z = [];
      if (i.value.length > 0) {
        const X = [...i.value].sort();
        z.push(X.join(" - "));
      }
      if (x.value.length > 0) {
        const X = x.value.length === 1 ? x.value[0] : x.value.map((ee) => `${ee}`).join(" and ");
        z.push(`in ${X}`);
      }
      return z.join(" ");
    }), y = k(() => i.value.length > 0 || r.value.length > 0);
    function S() {
      a.value = !a.value, V.user("Toggle panning", { panningEnabled: a.value }), a.value ? u.value && (u.value.style.cursor = "grab") : (m.value = !1, u.value && (u.value.style.cursor = ""));
    }
    function b() {
      const z = {
        populations: Te(n.populationsDataEntity.value),
        arms: Te(n.armsDataEntity.value),
        exposures: Te(n.exposuresDataEntity.value),
        interventions: Te(n.interventionsDataEntity.value),
        globalCriteria: Te(n.globalCriteria.value),
        globalCharacteristics: Te(n.globalCharacteristics.value),
        baselineName: n.baselineName.value
      };
      d("export", z);
    }
    function C(z) {
      if (!z || !(z instanceof HTMLElement)) return !1;
      const X = z.tagName.toLowerCase();
      return X === "input" || X === "textarea" || X === "select" || z.isContentEditable;
    }
    function B(z) {
      if (z.code === "Space" && !a.value) {
        if (C(z.target)) return;
        z.preventDefault(), c.value || (c.value = !0, u.value && (u.value.style.cursor = "grab"));
      }
    }
    function O(z) {
      if (z.code === "Space" && !a.value) {
        if (C(z.target)) return;
        z.preventDefault(), c.value = !1, m.value = !1, u.value && (u.value.style.cursor = "");
      }
    }
    function P(z) {
      !a.value && !c.value || !u.value || (z.preventDefault(), m.value = !0, f.value = z.clientX, v.value = z.clientY, T.value = u.value.scrollLeft, $.value = u.value.scrollTop, u.value.style.cursor = "grabbing", document.addEventListener("mousemove", U), document.addEventListener("mouseup", _));
    }
    function U(z) {
      if (!m.value || !u.value) return;
      z.preventDefault();
      const X = z.clientX - f.value, ee = z.clientY - v.value;
      u.value.scrollLeft = T.value - X, u.value.scrollTop = $.value - ee;
    }
    function _() {
      m.value && (m.value = !1, u.value && (a.value || c.value) ? u.value.style.cursor = "grab" : u.value && (u.value.style.cursor = ""), document.removeEventListener("mousemove", U), document.removeEventListener("mouseup", _));
    }
    return vt(() => {
      V.lifecycle("Builder component mounted"), globalThis.addEventListener("keydown", B), globalThis.addEventListener("keyup", O);
    }), Sn(() => {
      globalThis.removeEventListener("keydown", B), globalThis.removeEventListener("keyup", O), document.removeEventListener("mousemove", U), document.removeEventListener("mouseup", _);
    }), (z, X) => (w(), A("div", Js, [
      h(o) !== "thumbnail" ? (w(), A("div", Qs, [
        p("div", ea, [
          p("button", {
            onClick: S,
            class: J([
              "inline-flex text-gray-600 items-center justify-center w-9 h-9 rounded-lg border transition-all",
              a.value || c.value ? "bg-blue-100 border-blue-400 text-blue-700" : "bg-white border-slate-200 text-slate-700 hover:bg-slate-50"
            ]),
            title: a.value ? "Disable panning (hold Space)" : "Enable panning (hold Space)"
          }, [
            Q(Ns)
          ], 10, ta),
          X[2] || (X[2] = p("div", { class: "w-px h-6 bg-slate-300 mx-1" }, null, -1)),
          p("button", {
            onClick: X[0] || (X[0] = (ee) => d("toggleFullScreen")),
            class: "inline-flex items-center justify-center w-9 h-9 rounded-lg border border-slate-200 bg-white text-gray-600 transition-all hover:bg-slate-50",
            title: e.isFullScreen ? "Exit fullscreen" : "Enter fullscreen"
          }, [
            e.isFullScreen ? (w(), oe(js, { key: 1 })) : (w(), oe(Hs, { key: 0 }))
          ], 8, na),
          p("button", {
            onClick: b,
            class: "inline-flex items-center justify-center w-9 h-9 rounded-lg border border-slate-200 bg-white text-slate-700 transition-all hover:bg-slate-50",
            title: "Export study design"
          }, [
            Q(Xs)
          ]),
          p("button", {
            onClick: X[1] || (X[1] = (ee) => d("importClick")),
            class: "inline-flex items-center justify-center w-9 h-9 rounded-lg border border-slate-200 bg-white text-slate-700 transition-all hover:bg-slate-50",
            title: "Import study design"
          }, [
            Q(Ks)
          ]),
          h(o) === "select" && y.value ? (w(), A("div", oa, [
            p("span", ia, ne(g.value), 1)
          ])) : q("", !0)
        ]),
        In(z.$slots, "sync-status")
      ])) : q("", !0),
      p("div", {
        ref_key: "containerRef",
        ref: u,
        class: J(["dotted-grid-bg min-h-0 relative", [
          { "select-none": m.value },
          h(o) === "thumbnail" ? "overflow-hidden pointer-events-none" : "overflow-auto"
        ]]),
        onMousedown: P
      }, [
        p("div", {
          class: "flex min-h-40",
          style: ze(
            h(o) === "thumbnail" ? { transform: "scale(0.3)", transformOrigin: "top left" } : void 0
          )
        }, [
          Q(Bs),
          Q(Es)
        ], 4)
      ], 34)
    ]));
  }
}), ra = { class: "flex flex-col h-full" }, ma = /* @__PURE__ */ ae({
  __name: "VisualStudyDesignBuilder",
  props: /* @__PURE__ */ Ln({
    mode: { default: "edit" }
  }, {
    populations: {
      default: () => []
    },
    populationsModifiers: {},
    arms: { default: () => [] },
    armsModifiers: {},
    exposures: { default: () => [] },
    exposuresModifiers: {},
    interventions: {
      default: () => []
    },
    interventionsModifiers: {},
    globalCriteria: {
      default: () => []
    },
    globalCriteriaModifiers: {},
    globalCharacteristics: {
      default: () => []
    },
    globalCharacteristicsModifiers: {},
    baselineName: {
      default: "Baseline"
    },
    baselineNameModifiers: {}
  }),
  emits: /* @__PURE__ */ Ln(["export", "selectionChange"], ["update:populations", "update:arms", "update:exposures", "update:interventions", "update:globalCriteria", "update:globalCharacteristics", "update:baselineName"]),
  setup(e, { emit: t }) {
    const n = e, o = Je(e, "populations"), i = Je(e, "arms"), r = Je(e, "exposures"), l = Je(e, "interventions"), s = Je(e, "globalCriteria"), d = Je(e, "globalCharacteristics"), u = Je(e, "baselineName"), m = t, c = gl({
      populations: o.value,
      arms: i.value,
      exposures: r.value,
      interventions: l.value,
      globalCriteria: s.value,
      globalCharacteristics: d.value,
      baselineName: u.value,
      mode: n.mode
    });
    To(go, c), ce(
      () => n.mode,
      (x) => {
        c.mode.value = x, x === "edit" && c.clearSelection();
      }
    ), ce(
      [() => c.selectedTimepointNames.value, () => c.selectedInterventionIds.value],
      () => {
        m("selectionChange", c.getSelection());
      },
      { deep: !0 }
    ), ce(
      () => c.populationsDataEntity.value,
      (x) => {
        o.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.armsDataEntity.value,
      (x) => {
        i.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.exposuresDataEntity.value,
      (x) => {
        r.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.interventionsDataEntity.value,
      (x) => {
        l.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.globalCriteria.value,
      (x) => {
        s.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.globalCharacteristics.value,
      (x) => {
        d.value = Te(x);
      },
      { deep: !0 }
    ), ce(
      () => c.baselineName.value,
      (x) => {
        u.value = x;
      }
    );
    const a = M(!1), f = M(null);
    vt(() => {
      V.lifecycle("Visual Study Design Builder mounted");
    });
    function v() {
      V.user("Toggle fullscreen", {
        isFullScreen: !a.value
      }), a.value = !a.value;
    }
    function T(x) {
      V.user("Export button clicked"), m("export", x);
      const g = JSON.stringify(x, null, 2), y = new Blob([g], { type: "application/json" }), S = URL.createObjectURL(y), b = document.createElement("a");
      b.href = S, b.download = `study-design-${Date.now()}.json`, b.click(), URL.revokeObjectURL(S);
    }
    function $() {
      V.user("Import button clicked"), f.value?.click();
    }
    async function E(x) {
      const g = x.target, y = g.files?.[0];
      if (y) {
        try {
          const S = await y.text(), b = JSON.parse(S);
          c.importStudyDesign(b), V.user("Study design imported successfully");
        } catch (S) {
          V.state.warn("Failed to import study design", { error: S }), alert("Failed to import study design. Please check the file format.");
        }
        g.value = "";
      }
    }
    return (x, g) => (w(), A("div", ra, [
      p("input", {
        ref_key: "fileInputRef",
        ref: f,
        type: "file",
        accept: ".json",
        class: "hidden",
        onChange: E
      }, null, 544),
      p("div", {
        class: J(["bg-white flex rounded-xl shadow-sm border border-slate-200 min-w-0 min-h-0 h-full", a.value ? "fixed top-0 left-0 w-screen h-screen z-100" : ""])
      }, [
        Q(la, {
          "is-full-screen": a.value,
          onToggleFullScreen: v,
          onExport: T,
          onImportClick: $
        }, {
          "sync-status": Pe(() => [
            In(x.$slots, "sync-status")
          ]),
          _: 3
        }, 8, ["is-full-screen"])
      ], 2)
    ]));
  }
}), sa = ["viewBox"], aa = ["d"], ua = ["y1", "x2", "y2"], ca = ["x", "y", "width", "fill", "rx", "ry"], da = ["x", "y"], va = ["cy", "fill"], fa = ["transform"], Gn = 520, dn = 200, Nt = 16, vn = 36, Yn = 30, Qe = 104, xt = 22, fn = 6, _n = 10, pn = 150, Kn = 5.5, ga = /* @__PURE__ */ ae({
  __name: "StudyDesignThumbnail",
  props: {
    populations: {},
    arms: {},
    exposures: {},
    interventions: {}
  },
  setup(e) {
    const t = e, n = vn + Yn, o = Math.round((n + Qe) / 2), i = [
      "#ea580c",
      // orange-600
      "#2563eb",
      // blue-600
      "#16a34a",
      // green-600
      "#9333ea",
      // purple-600
      "#db2777",
      // pink-600
      "#0d9488",
      // teal-600
      "#d97706",
      // amber-600
      "#0891b2"
      // cyan-600
    ], r = k(() => Math.max(t.populations.length, 1)), l = k(() => (dn - 2 * Nt) / r.value);
    function s(x) {
      return t.arms.filter((g) => g.populationId === x);
    }
    function d(x, g, y) {
      const S = s(y), b = l.value / Math.max(S.length, 1);
      return Nt + x * l.value + (g + 0.5) * b;
    }
    function u(x) {
      const g = t.populations[x];
      if (!g) return Nt + (x + 0.5) * l.value;
      const y = s(g.id);
      if (y.length === 0) return Nt + (x + 0.5) * l.value;
      const S = y.map((b, C) => d(x, C, g.id));
      return S.reduce((b, C) => b + C, 0) / S.length;
    }
    function m(x, g) {
      const y = x.exposureIds[0];
      if (y) {
        const S = fo(t.exposures, y);
        return i[S] ?? "#94a3b8";
      }
      return i[g % i.length] ?? "#94a3b8";
    }
    function c(x) {
      return x.exposureIds.map((g) => t.exposures.find((y) => y.id === g)?.name ?? "").filter(Boolean).join(" + ");
    }
    const a = k(() => {
      const x = [];
      for (let g = 0; g < t.populations.length; g++) {
        const y = t.populations[g];
        if (!y) continue;
        const S = s(y.id);
        for (let b = 0; b < S.length; b++)
          x.push({ id: S[b].id, y: d(g, b, y.id) });
      }
      return x;
    }), f = k(() => {
      const x = /* @__PURE__ */ new Map();
      for (const g of a.value) x.set(g.id, { y: g.y });
      return x;
    }), v = k(() => {
      const x = /* @__PURE__ */ new Map();
      for (const g of a.value) {
        const y = t.interventions.filter((b) => b.armId === g.id);
        if (y.length === 0) {
          x.set(g.id, Qe);
          continue;
        }
        let S = Qe;
        for (const b of y)
          S += $(c(b)).w + fn;
        x.set(g.id, S - fn);
      }
      return x;
    }), T = k(() => {
      const x = [], g = o;
      for (let y = 0; y < t.populations.length; y++) {
        const S = t.populations[y];
        if (!S) continue;
        const b = s(S.id), C = u(y);
        if (b.length !== 0)
          for (const B of b) {
            const O = f.value.get(B.id);
            if (!O) continue;
            const P = O.y;
            x.push({
              d: `M ${n} ${C} C ${g} ${C} ${g} ${P} ${Qe} ${P}`
            });
          }
      }
      return x;
    });
    function $(x) {
      const g = x.length * Kn + 2 * _n;
      if (g <= pn) return { w: g, text: x };
      const y = Math.floor((pn - 2 * _n) / Kn);
      return { w: pn, text: x.slice(0, Math.max(y - 1, 1)) + "…" };
    }
    const E = k(() => {
      const x = [];
      let g = 0;
      for (const y of a.value) {
        const S = t.interventions.filter((B) => B.armId === y.id), b = S.length;
        if (b === 0) {
          g++;
          continue;
        }
        let C = Qe;
        for (let B = 0; B < b; B++) {
          const O = S[B], { w: P, text: U } = $(c(O));
          x.push({
            x: C,
            y: y.y - xt / 2,
            w: P,
            color: m(O, g),
            label: U
          }), C += P + fn;
        }
        g++;
      }
      return x;
    });
    return (x, g) => (w(), A("svg", {
      viewBox: `0 0 ${Gn} ${dn}`,
      preserveAspectRatio: "xMidYMid meet",
      class: "w-full h-full",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      g[1] || (g[1] = p("defs", null, [
        p("pattern", {
          id: "sdthumb-dots",
          x: "0",
          y: "0",
          width: "12",
          height: "12",
          patternUnits: "userSpaceOnUse"
        }, [
          p("circle", {
            cx: "1.5",
            cy: "1.5",
            r: "0.8",
            fill: "#cbd5e1"
          })
        ])
      ], -1)),
      p("rect", {
        width: Gn,
        height: dn,
        fill: "url(#sdthumb-dots)"
      }),
      (w(!0), A(de, null, pe(T.value, ({ d: y }, S) => (w(), A("path", {
        key: `conn-${S}`,
        d: y,
        stroke: "#475569",
        "stroke-width": "3",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, aa))), 128)),
      (w(!0), A(de, null, pe(a.value, (y) => (w(), A("line", {
        key: `track-${y.id}`,
        x1: Qe,
        y1: y.y,
        x2: v.value.get(y.id) ?? Qe,
        y2: y.y,
        stroke: "#cbd5e1",
        "stroke-width": "2",
        "stroke-linecap": "round"
      }, null, 8, ua))), 128)),
      (w(!0), A(de, null, pe(E.value, (y, S) => (w(), A("g", {
        key: `pill-${S}`
      }, [
        p("rect", {
          x: y.x,
          y: y.y,
          width: y.w,
          height: xt,
          fill: y.color,
          rx: xt / 2,
          ry: xt / 2
        }, null, 8, ca),
        p("text", {
          x: y.x + y.w / 2,
          y: y.y + xt / 2,
          "dominant-baseline": "middle",
          "text-anchor": "middle",
          fill: "white",
          "font-size": "9",
          "font-family": "system-ui, sans-serif",
          "font-weight": "600"
        }, ne(y.label), 9, da)
      ]))), 128)),
      (w(!0), A(de, null, pe(e.populations, (y, S) => (w(), A("g", {
        key: `pop-${y.id}`
      }, [
        p("circle", {
          cx: vn,
          cy: u(S),
          r: Yn,
          fill: h(vo)(S),
          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.25))"
        }, null, 8, va),
        p("g", {
          transform: `translate(${vn - 10}, ${u(S) - 8}) scale(0.56)`
        }, [...g[0] || (g[0] = [
          $n('<path d="M24 6C24 9.31371 21.3137 12 18 12C14.6863 12 12 9.31371 12 6C12 2.68629 14.6863 0 18 0C21.3137 0 24 2.68629 24 6Z" fill="white"></path><path d="M34 10C34 12.2091 32.2091 14 30 14C27.7909 14 26 12.2091 26 10C26 7.79086 27.7909 6 30 6C32.2091 6 34 7.79086 34 10Z" fill="white"></path><path d="M26 24C26 19.5817 22.4183 16 18 16C13.5817 16 10 19.5817 10 24V30H26V24Z" fill="white"></path><path d="M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10Z" fill="white"></path><path d="M30 30V24C30 21.8917 29.4563 19.9104 28.5015 18.1886C28.9805 18.0655 29.4826 18 30 18C33.3137 18 36 20.6863 36 24V30H30Z" fill="white"></path><path d="M7.49853 18.1886C6.5437 19.9104 6 21.8917 6 24V30H0V24C0 20.6863 2.68629 18 6 18C6.51742 18 7.01954 18.0655 7.49853 18.1886Z" fill="white"></path>', 6)
        ])], 8, fa)
      ]))), 128))
    ], 8, sa));
  }
});
export {
  ga as StudyDesignThumbnail,
  ma as VisualStudyDesignBuilder
};
//# sourceMappingURL=index.js.map
